(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[18],{

/***/ "/HC4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FormikInput_FormikInput; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 76 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: /opt/webapp/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/inputsUtils.js
var inputsUtils = __webpack_require__("vpua");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/pick.js
var pick = __webpack_require__("//nZ");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/kebabCase.js
var kebabCase = __webpack_require__("s2Gj");
var kebabCase_default = /*#__PURE__*/__webpack_require__.n(kebabCase);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/get.js
var get = __webpack_require__("2srY");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/image-validation-status/ImageValidationStatus.jsx
var __jsx = react_default.a.createElement;





var ImageValidationStatus_ImageValidationStatus = function ImageValidationStatus(_ref) {
  var className = _ref.className,
      isErrored = _ref.isErrored,
      isValidated = _ref.isValidated;
  return __jsx(react["Fragment"], null, isErrored && __jsx(Icon["a" /* Icon */], {
    className: classnames_default()(className, 'pointer-events-none'),
    color: colors["a" /* COLORS */].RED,
    name: icons["a" /* ICONS */].CROSS,
    width: "0.8125rem"
  }), isValidated && __jsx(Icon["a" /* Icon */], {
    className: classnames_default()(className, 'pointer-events-none'),
    color: colors["a" /* COLORS */].SUCCESS,
    name: icons["a" /* ICONS */].CHECK,
    width: "0.8125rem"
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/BirthDateInputSeparator.jsx
var BirthDateInputSeparator_jsx = react_default.a.createElement;


var BirthDateInputSeparator_BirthDateInputSeparator = function BirthDateInputSeparator(_ref) {
  var isDisabled = _ref.isDisabled,
      isErrored = _ref.isErrored,
      isValidated = _ref.isValidated,
      position = _ref.position;
  return BirthDateInputSeparator_jsx("span", {
    className: classnames_default()('absolute flex h-full items-center pointer-events-none', {
      'text-success': isValidated && !isDisabled,
      'text-red': isErrored && !isDisabled
    }),
    style: {
      left: "".concat(position / 3 * 100, "%")
    }
  }, "/");
};
// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/ErrorNote.jsx
var ErrorNote = __webpack_require__("TuHz");

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/Legend.jsx
var Legend = __webpack_require__("hUUf");

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/DateInput.jsx





















var DateInput_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var DateInput_DateInput = function DateInput(_ref) {
  var air360ClassName = _ref.air360ClassName,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      dateFormat = _ref.dateFormat,
      dayPlaceholder = _ref.dayPlaceholder,
      field = _ref.field,
      form = _ref.form,
      hideErrorMessage = _ref.hideErrorMessage,
      isDisabled = _ref.isDisabled,
      isRequired = _ref.isRequired,
      label = _ref.label,
      labelAdditionalInfo = _ref.labelAdditionalInfo,
      monthPlaceholder = _ref.monthPlaceholder,
      onKeyDown = _ref.onKeyDown,
      yearPlaceholder = _ref.yearPlaceholder,
      errorMessage = _ref.errorMessage,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["air360ClassName", "className", "dataTestId", "dateFormat", "dayPlaceholder", "field", "form", "hideErrorMessage", "isDisabled", "isRequired", "label", "labelAdditionalInfo", "monthPlaceholder", "onKeyDown", "yearPlaceholder", "errorMessage"]);

  var _getValidationStatus = Object(inputsUtils["e" /* getValidationStatus */])(field, form, isDisabled),
      isValidated = _getValidationStatus.isValidated,
      isErrored = _getValidationStatus.isErrored,
      isDefaultState = _getValidationStatus.isDefaultState;

  var _useRef = Object(react["useRef"])("dateInput-".concat(field.name)),
      uniqIdentifier = _useRef.current;

  var refFirstInput = Object(react["useRef"])(null);
  var errorNoteId = "error-".concat(kebabCase_default()(field.name)); // Form state (global)

  var date = Object(react["useMemo"])(function () {
    return field.value ? moment_default()(field.value) : null;
  }, [field.value]);
  var dateDay = date && date.isValid() ? date.format('DD') : '';
  var dateMonth = date && date.isValid() ? date.format('MM') : '';
  var dateYear = date && date.isValid() ? date.format('YYYY') : ''; // Field state (local)

  var _useState = Object(react["useState"])(dateDay),
      day = _useState[0],
      setDay = _useState[1];

  var _useState2 = Object(react["useState"])(dateMonth),
      month = _useState2[0],
      setMonth = _useState2[1];

  var _useState3 = Object(react["useState"])(dateYear),
      year = _useState3[0],
      setYear = _useState3[1];

  var onChangeDay = function onChangeDay(_ref2) {
    var target = _ref2.target;
    setDay(target.value);
    Object(inputsUtils["b" /* focusNextInput */])(target);
  };

  var onChangeMonth = function onChangeMonth(_ref3) {
    var target = _ref3.target;
    setMonth(target.value);
    Object(inputsUtils["b" /* focusNextInput */])(target);
  };

  var onChangeYear = function onChangeYear(_ref4) {
    var target = _ref4.target;
    setYear(target.value);
    Object(inputsUtils["b" /* focusNextInput */])(target);
  };

  var structure = [{
    keyPos: 'd',
    name: "".concat(field.name, "-BirthdateInput-day"),
    value: day || dateDay,
    title: 'Day',
    length: 2,
    handleChange: onChangeDay,
    placeholder: dayPlaceholder
  }, {
    keyPos: 'm',
    name: "".concat(field.name, "-BirthdateInput-month"),
    value: month || dateMonth,
    title: 'Month',
    length: 2,
    handleChange: onChangeMonth,
    placeholder: monthPlaceholder
  }, {
    keyPos: 'y',
    name: "".concat(field.name, "-BirthdateInput-year"),
    value: year || dateYear,
    title: 'Year',
    length: 4,
    handleChange: onChangeYear,
    placeholder: yearPlaceholder
  }].sort( // sort each input to respect the locale format (DD/MM/YYYY or YYYY/MM/DD ...)
  function (i1, i2) {
    return dateFormat.toLowerCase().indexOf(i1.keyPos) - dateFormat.toLowerCase().indexOf(i2.keyPos);
  }); // Update form state on field change

  Object(react["useEffect"])(function () {
    if (structure.every(function (_ref5) {
      var value = _ref5.value,
          length = _ref5.length;
      return value.length === length;
    })) {
      var birthdate = moment_default()([+year, +month - 1, +day]).valueOf();
      form.setFieldValue(field.name, birthdate);
    } else {
      form.setFieldValue(field.name, null);
    }
  }, [day, month, year]);
  Object(react["useEffect"])(function () {
    if (day !== dateDay) {
      setDay(dateDay);
    }

    if (month !== dateMonth) {
      setMonth(dateMonth);
    }

    if (year !== dateYear) {
      setYear(dateYear);
    }
  }, [dateDay, dateMonth, dateYear]);

  var handleBlur = function handleBlur(_ref6) {
    var relatedTarget = _ref6.relatedTarget;

    if (!relatedTarget || !relatedTarget.dataset.dateinputidentifier || !relatedTarget.dataset.dateinputidentifier.includes('uniqIdentifier')) {
      form.setFieldTouched(field.name);
    }
  };

  var handleFocus = function handleFocus(_ref7) {
    var target = _ref7.target;

    if (structure.every(function (_ref8) {
      var value = _ref8.value;
      return value === '';
    }) && refFirstInput.current && target !== refFirstInput.current) {
      refFirstInput.current.focus();
    }
  };

  var dataCsMask = pick_default()(props, 'data-cs-mask');

  var classes = Object(inputsUtils["c" /* getInputClasses */])({
    hasHeight: true,
    hasValidationStatus: true,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated
  });
  return DateInput_jsx("fieldset", {
    className: className
  }, !!label && DateInput_jsx(Legend["a" /* Legend */], {
    className: "mb-5 mx-15",
    isDisabled: isDisabled,
    isRequired: isRequired,
    label: label,
    labelAdditionalInfo: labelAdditionalInfo
  }), DateInput_jsx("div", {
    className: classnames_default()(classes, 'direction-ltr flex isolate items-center relative w-full'),
    "data-testid": dataTestId ? "wrapper-".concat(dataTestId) : undefined
  }, DateInput_jsx("div", {
    className: "flex flex-1 isolate items-stretch relative"
  }, structure.map(function (_ref9, key) {
    var name = _ref9.name,
        handleChange = _ref9.handleChange,
        value = _ref9.value,
        length = _ref9.length,
        placeholder = _ref9.placeholder,
        title = _ref9.title;
    return DateInput_jsx("input", Object(esm_extends["a" /* default */])({
      "aria-describedby": errorNoteId,
      autoComplete: "off",
      className: classnames_default()(air360ClassName, 'bg-transparent leading-normal overflow-hidden outline-none py-10 text-16 sm:text-14 text-center w-full', {
        'cursor-not-allowed': isDisabled
      }),
      "data-dateinputidentifier": uniqIdentifier
    }, dataCsMask, {
      "data-testid": "".concat(dataTestId || kebabCase_default()(field.name), "-").concat(title.toLowerCase()),
      disabled: isDisabled,
      key: name,
      maxLength: length,
      name: name,
      onBlur: handleBlur,
      onChange: handleChange,
      onFocus: handleFocus,
      onKeyDown: onKeyDown,
      placeholder: placeholder,
      ref: key === 0 ? refFirstInput : undefined,
      style: _objectSpread({
        height: inputsUtils["a" /* INPUT_HEIGHT */]
      }, isDisabled ? {
        WebkitTextFillColor: '#a0a0a0',
        opacity: 1
      } : {}),
      title: title,
      type: "tel",
      value: value
    }));
  }), DateInput_jsx(BirthDateInputSeparator_BirthDateInputSeparator, {
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated,
    position: 1
  }), DateInput_jsx(BirthDateInputSeparator_BirthDateInputSeparator, {
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated,
    position: 2
  })), !isDisabled && DateInput_jsx(ImageValidationStatus_ImageValidationStatus, {
    className: "absolute end-0 mx-20",
    isErrored: isErrored,
    isValidated: isValidated
  })), !hideErrorMessage && DateInput_jsx(ErrorNote["a" /* ErrorNote */], {
    className: "mx-15",
    errorMessage: errorMessage !== null && errorMessage !== void 0 ? errorMessage : get_default()(form.errors, field.name),
    errorNoteId: errorNoteId,
    isErrored: isErrored
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/Checkbox.jsx















var Checkbox_jsx = react_default.a.createElement;

function Checkbox_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Checkbox_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Checkbox_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Checkbox_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var Checkbox_Checkbox = function Checkbox(_ref) {
  var ariaDescribedBy = _ref.ariaDescribedBy,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      field = _ref.field,
      form = _ref.form,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? colors["a" /* COLORS */].BLACK : _ref$iconColor,
      iconName = _ref.iconName,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      label = _ref.label,
      _onChange = _ref.onChange,
      onClick = _ref.onClick,
      placeholderComponent = _ref.placeholderComponent;

  // Checkbox value defaults to false
  var value = get_default()(form.values, field.name, false);

  var _getValidationStatus = Object(inputsUtils["e" /* getValidationStatus */])(Checkbox_objectSpread(Checkbox_objectSpread({}, field), {}, {
    value: value
  }), form, isDisabled),
      isValidated = _getValidationStatus.isValidated,
      isErrored = _getValidationStatus.isErrored;

  var checkboxId = "checkbox-".concat(kebabCase_default()(field.name));
  return Checkbox_jsx("div", {
    className: classnames_default()(className, 'flex gap-10 items-center justify-between text-14', {
      'formik-errored': isErrored && isRequired
    })
  }, iconName && Checkbox_jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    color: iconColor,
    name: iconName,
    width: "1em"
  }), Checkbox_jsx("label", {
    className: classnames_default()('flex gap-10 items-center w-full', {
      'cursor-pointer': !isDisabled,
      'cursor-not-allowed': isDisabled,
      'leading-0': !placeholderComponent
    }),
    htmlFor: checkboxId
  }, Checkbox_jsx("input", Object(esm_extends["a" /* default */])({
    "aria-describedby": ariaDescribedBy,
    className: "sr-only",
    "data-testid": dataTestId,
    disabled: isDisabled,
    id: checkboxId,
    type: "checkbox"
  }, field, {
    checked: value,
    onChange: function onChange(e) {
      field.onChange(e);

      if (_onChange) {
        _onChange(e);
      }
    },
    onClick: onClick ? onClick : field.onClick
  })), !placeholderComponent && Checkbox_jsx("span", {
    className: classnames_default()('border flex h-[1.5rem] items-center justify-center p-2 outline-custom-sibling rounded-8 shrink-0 w-[1.5rem]', {
      'border-black': !isDisabled,
      'bg-pearl border-grey': isDisabled,
      'text-success': isValidated && isRequired,
      'text-red formik-errored': isErrored && isRequired
    })
  }, !!value && Checkbox_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].BLACK,
    name: icons["a" /* ICONS */].CHECK,
    width: "1em"
  })), label && Checkbox_jsx("span", {
    className: "font-bold inline-block leading-tight mt-1 text-14 text-black"
  }, Checkbox_jsx("span", null, label), isRequired && '*'), placeholderComponent && placeholderComponent(value)));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/shortid/index.js
var shortid = __webpack_require__("MIfU");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/CreditCardExpiryInput.jsx








var CreditCardExpiryInput_jsx = react_default.a.createElement;





var CreditCardExpiryInput_CreditCardExpiryInput = function CreditCardExpiryInput(_ref) {
  var className = _ref.className,
      label = _ref.label,
      field = _ref.field,
      isRequired = _ref.isRequired,
      isDisabled = _ref.isDisabled,
      form = _ref.form,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["className", "label", "field", "isRequired", "isDisabled", "form"]);

  var _getValidationStatus = Object(inputsUtils["e" /* getValidationStatus */])(field, form),
      isDefaultState = _getValidationStatus.isDefaultState,
      isErrored = _getValidationStatus.isErrored,
      isValidated = _getValidationStatus.isValidated;

  var _useRef = Object(react["useRef"])("dateInput-".concat(shortid_default.a.generate())),
      uniqIdentifier = _useRef.current;

  var refFirstInput = Object(react["useRef"])(null);

  var _useState = Object(react["useState"])(''),
      month = _useState[0],
      setMonth = _useState[1];

  var _useState2 = Object(react["useState"])(''),
      year = _useState2[0],
      setYear = _useState2[1];

  var onChangeMonth = function onChangeMonth(_ref2) {
    var target = _ref2.target;
    setMonth(target.value);
    Object(inputsUtils["b" /* focusNextInput */])(target);
  };

  var onChangeYear = function onChangeYear(_ref3) {
    var target = _ref3.target;
    setYear(target.value);
    Object(inputsUtils["b" /* focusNextInput */])(target);
  };

  var structure = [{
    keyPos: 'm',
    name: "".concat(field.name, "-CreditCardExpiryInput-month"),
    value: month,
    length: 2,
    handleChange: onChangeMonth,
    placeholder: props.monthPlaceholder
  }, {
    keyPos: 'y',
    name: "".concat(field.name, "-CreditCardExpiryInput-year"),
    value: year,
    length: 4,
    handleChange: onChangeYear,
    placeholder: props.yearPlaceholder
  }].sort( // sort each input to respect the locale format (MM/YYYY or YYYY/MM ...)
  function (i1, i2) {
    return props.dateFormat.toLowerCase().indexOf(i1.keyPos) - props.dateFormat.toLowerCase().indexOf(i2.keyPos);
  });
  Object(react["useEffect"])(function () {
    // if no value is entered, no need to set fields to null
    if (!month && !year) {
      return;
    } // when the date is incomplete erase the stored birth date to null to not store an invalid date


    if (!structure.every(function (_ref4) {
      var value = _ref4.value,
          length = _ref4.length;
      return value.length === length;
    })) {
      /**
       * setFieldValue returns a promise even if the doc says the opposite
       * https://github.com/jaredpalmer/formik/blob/f117c04738ed218b5eb8916d7189e0849962d50d/packages/formik/src/Formik.tsx#L602
       * BUT useEffect does not allow a promise as return...
       */
      form.setFieldValue(field.name, null);
      return;
    }

    var expiryDate = moment_default()([+year, +month - 1]);
    form.setFieldValue(field.name, expiryDate.valueOf());
  }, [month, year]);

  var handleBlur = function handleBlur(_ref5) {
    var relatedTarget = _ref5.relatedTarget;

    if (!relatedTarget || !relatedTarget.dataset.dateinputidentifier || !relatedTarget.dataset.dateinputidentifier.includes('uniqIdentifier')) {
      form.setFieldTouched(field.name);
    }
  };

  var handleFocus = function handleFocus(_ref6) {
    var target = _ref6.target;

    if (structure.every(function (_ref7) {
      var value = _ref7.value;
      return value === '';
    }) && refFirstInput.current && target !== refFirstInput.current) {
      refFirstInput.current.focus();
    }
  };

  var classes = Object(inputsUtils["c" /* getInputClasses */])({
    hasHeight: true,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: form.touched[field.name] && isErrored,
    isValidated: isValidated
  });
  return CreditCardExpiryInput_jsx("div", {
    className: classnames_default()(className, classes, 'flex isolate relative')
  }, structure.map(function (_ref8, key) {
    var name = _ref8.name,
        handleChange = _ref8.handleChange,
        value = _ref8.value,
        length = _ref8.length,
        placeholder = _ref8.placeholder;
    return CreditCardExpiryInput_jsx("input", {
      autoComplete: "off",
      className: "outline-none",
      ref: key === 0 ? refFirstInput : undefined,
      key: name,
      name: name,
      type: "tel",
      onChange: handleChange,
      onBlur: handleBlur,
      onFocus: handleFocus,
      maxLength: length,
      value: value,
      placeholder: placeholder,
      disabled: isDisabled,
      "data-dateinputidentifier": uniqIdentifier
    });
  }), CreditCardExpiryInput_jsx("span", {
    className: classnames_default()('absolute flex items-center left-1/2 pointer-events-none', {
      'text-success': isValidated,
      'text-red': form.touched[field.name] && isErrored
    })
  }, "/"));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/useStateRef.js


var useStateRef_useStateRef = function useStateRef(initalState) {
  var _useState = Object(react["useState"])(initalState),
      state = _useState[0],
      setState = _useState[1];

  var ref = Object(react["useRef"])(initalState);

  var setStateRef = function setStateRef(newState) {
    setState(newState);
    ref.current = newState;
  };

  return [state, setStateRef, ref];
};

/* harmony default export */ var formik_input_useStateRef = (useStateRef_useStateRef);
// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/DatalistInput.jsx









var DatalistInput_jsx = react_default.a.createElement;




var labelMatch = function labelMatch(currentInput, item) {
  return item.label.substr(0, currentInput.length).toLowerCase() === currentInput.toLowerCase();
};

var indexOfMatch = function indexOfMatch(currentInput, item) {
  return item.label.toLowerCase().indexOf(currentInput.toLowerCase());
};

var indexOfItem = function indexOfItem(item, items) {
  return items.indexOf(items.find(function (i) {
    return i.key === item.key;
  }));
};

var DatalistInput_DataListInput = function DataListInput(_ref) {
  var className = _ref.className,
      dataTestId = _ref.dataTestId,
      activeItemClassName = _ref.activeItemClassName,
      dropdownClassName = _ref.dropdownClassName,
      dropDownLength = _ref.dropDownLength,
      value = _ref.value,
      inputClassName = _ref.inputClassName,
      itemClassName = _ref.itemClassName,
      onSelect = _ref.onSelect,
      onBlur = _ref.onBlur,
      placeholder = _ref.placeholder,
      _ref$requiredInputLen = _ref.requiredInputLength,
      requiredInputLength = _ref$requiredInputLen === void 0 ? 1 : _ref$requiredInputLen,
      items = _ref.items,
      field = _ref.field;

  var _useState = Object(react["useState"])(),
      lastValidItem = _useState[0],
      setLastValidItem = _useState[1];

  var _useStateRef = formik_input_useStateRef(value !== undefined ? value : ''),
      _useStateRef2 = Object(slicedToArray["a" /* default */])(_useStateRef, 3),
      currentInput = _useStateRef2[0],
      setCurrentInput = _useStateRef2[1],
      currentInputRef = _useStateRef2[2];

  var _useState2 = Object(react["useState"])([]),
      matchingItems = _useState2[0],
      setMatchingItems = _useState2[1];

  var _useStateRef3 = formik_input_useStateRef(false),
      _useStateRef4 = Object(slicedToArray["a" /* default */])(_useStateRef3, 3),
      visible = _useStateRef4[0],
      setVisible = _useStateRef4[1],
      visibleRef = _useStateRef4[2];

  var _useState3 = Object(react["useState"])(0),
      focusIndex = _useState3[0],
      setFocusIndex = _useState3[1];

  var interactionHappenedRef = Object(react["useRef"])(false);

  var _useState4 = Object(react["useState"])(false),
      isMatchingDebounced = _useState4[0],
      setIsMatchingDebounced = _useState4[1];

  var menu = Object(react["useRef"])();
  var inputField = Object(react["useRef"])();
  Object(react["useEffect"])(function () {
    var onClickCloseMenu = function onClickCloseMenu(event) {
      if (!menu.current) {
        return;
      } // if rerender, items inside might change, allow one click without further checking


      if (interactionHappenedRef.current) {
        interactionHappenedRef.current = false;
        return;
      } // do not do anything if input is clicked, as we have a dedicated func for that


      if (!inputField.current) {
        return;
      }

      var targetIsInput = event.target === inputField.current;
      var targetInInput = inputField.current.contains(event.target);

      if (targetIsInput || targetInInput) {
        return;
      } // do not close menu if user clicked inside


      var targetInMenu = menu.current.contains(event.target);
      var targetIsMenu = event.target === menu.current;

      if (targetInMenu || targetIsMenu) {
        return;
      }

      if (visibleRef.current) {
        setVisible(false);
        setFocusIndex(-1);
      }
    };

    window.addEventListener('click', onClickCloseMenu, false);
    return function () {
      window.removeEventListener('click', onClickCloseMenu);
    };
  }, [setVisible, visibleRef]);
  Object(react["useEffect"])(function () {
    var isValuePropSet = value !== undefined;
    var isValueDifferent = currentInputRef.current !== value;
    var isMatchingRunning = visible || isMatchingDebounced;

    if (isValuePropSet && isValueDifferent && !isMatchingRunning) {
      setCurrentInput(value);
    }
  }, [visible, isMatchingDebounced, value, setCurrentInput, currentInputRef]);
  var debouncedMatchingUpdateStep = Object(react["useCallback"])(function (nextInput) {
    var reachedRequiredLength = nextInput.length >= requiredInputLength;
    var showMatchingStillLoading = false;
    setCurrentInput(nextInput);
    setIsMatchingDebounced(showMatchingStillLoading); // no matching if we do not reach required input length

    if (!reachedRequiredLength) {
      return;
    }

    var updateMatchingItems = function updateMatchingItems() {
      // matching process to find matching entries in items array
      var updatedMatchingItems = items.filter(function (item) {
        return labelMatch(nextInput, item);
      });
      var displayableItems = updatedMatchingItems.slice(0, dropDownLength);
      var showDragIndex = !!lastValidItem;
      var index = showDragIndex ? indexOfItem(lastValidItem, displayableItems) : 0;

      if (displayableItems.length) {
        setMatchingItems(displayableItems);
        setFocusIndex(index > 0 ? index : 0);
        setIsMatchingDebounced(false);
        setVisible(true);
      } else {
        if (visibleRef.current) {
          setVisible(false);
        }

        setMatchingItems(displayableItems);
        setFocusIndex(-1);
        setIsMatchingDebounced(false);
      }
    };

    updateMatchingItems();
  }, [requiredInputLength, setCurrentInput, items, dropDownLength, lastValidItem, setVisible, visibleRef]);
  var onHandleInput = Object(react["useCallback"])(function (event) {
    var newValue = event.target.value;
    debouncedMatchingUpdateStep(newValue);
  }, [debouncedMatchingUpdateStep]);
  var onClickInput = Object(react["useCallback"])(function () {
    var currentValue = currentInputRef.current;
    var reachedRequiredLength = currentValue.length >= requiredInputLength;

    if (reachedRequiredLength && !visibleRef.current) {
      debouncedMatchingUpdateStep(currentValue);
    }
  }, [currentInputRef, requiredInputLength, visibleRef, debouncedMatchingUpdateStep]);
  var onHandleBlur = Object(react["useCallback"])(function (event) {
    var newValue = event.target.value;
    onBlur(newValue);
  }, [onBlur]);
  var onHandleSelect = Object(react["useCallback"])(function (selectedItem) {
    if (isMatchingDebounced) {
      return;
    }

    setCurrentInput(selectedItem.label);
    setVisible(false);
    setFocusIndex(-1);
    interactionHappenedRef.current = true;
    setLastValidItem((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.key) || selectedItem);
    onSelect((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.key) || selectedItem);
  }, [isMatchingDebounced, setCurrentInput, setVisible, lastValidItem, onSelect]);
  var onHandleKeydown = Object(react["useCallback"])(function (event) {
    if (!visibleRef.current) {
      return;
    }

    var currentFocusIndex = focusIndex;

    if (event.keyCode === 40 || event.keyCode === 9) {
      currentFocusIndex += 1;

      if (currentFocusIndex >= matchingItems.length) {
        currentFocusIndex = 0;
      }

      setFocusIndex(currentFocusIndex);
      event.preventDefault();
    } else if (event.keyCode === 38) {
      currentFocusIndex -= 1;

      if (currentFocusIndex <= -1) {
        currentFocusIndex = matchingItems.length - 1;
      }

      setFocusIndex(currentFocusIndex);
    } else if (event.keyCode === 13) {
      if (focusIndex > -1) {
        var selectedItem = matchingItems[currentFocusIndex];
        onHandleSelect(selectedItem);
      }
    }
  }, [focusIndex, matchingItems, onHandleSelect, visibleRef]);
  var renderItemLabel = Object(react["useCallback"])(function (item) {
    var index = indexOfMatch(currentInput, item);
    var inputLength = currentInput.length;
    return index >= 0 && inputLength ? // renders label with matching search string marked
    DatalistInput_jsx(react["Fragment"], null, item.label.substr(0, index), DatalistInput_jsx("strong", null, item.label.substr(index, inputLength)), item.label.substr(index + inputLength, item.label.length)) : item.label;
  }, [currentInput]);
  var renderItems = Object(react["useCallback"])(function () {
    return DatalistInput_jsx(react["Fragment"], null, matchingItems.map(function (item, i) {
      var isActive = focusIndex === i;
      var itemActiveClasses = isActive ? "cursor-pointer ".concat(activeItemClassName || 'bg-saffron text-white border-solid border-grey-light p-10;') : '';
      var itemClasses = "".concat(itemClassName, " ").concat(itemActiveClasses);
      return DatalistInput_jsx("div", {
        onClick: function onClick() {
          return onHandleSelect(item);
        },
        className: itemClasses,
        key: item.key,
        tabIndex: 0,
        role: "button",
        "aria-label": item.label,
        onKeyUp: function onKeyUp(event) {
          return event.preventDefault();
        }
      }, renderItemLabel(item));
    }));
  }, [matchingItems, focusIndex, activeItemClassName, itemClassName, onHandleSelect, renderItemLabel]);
  var dropDown = Object(react["useMemo"])(function () {
    var reachedRequiredLength = currentInputRef.current.length >= requiredInputLength;

    if (reachedRequiredLength && isMatchingDebounced) {
      return DatalistInput_jsx("div", {
        ref: menu,
        className: "absolute z-1 top-full inset-x-0 ".concat(dropdownClassName || 'p-10 cursor-pointer bg-white border border-solid grey-light'),
        role: "dialog",
        "aria-label": "Dropdown menu"
      }, DatalistInput_jsx("div", {
        className: itemClassName
      }, "loading..."));
    }

    if (reachedRequiredLength && visible) {
      return DatalistInput_jsx("div", {
        ref: menu,
        className: "absolute z-1 top-full inset-x-0 ".concat(dropdownClassName || 'p-10 cursor-pointer bg-white border border-solid grey-light'),
        role: "dialog",
        "aria-label": "Dropdown menu"
      }, renderItems());
    }

    return undefined;
  }, [currentInputRef, requiredInputLength, isMatchingDebounced, visible, dropdownClassName, itemClassName, renderItems]);
  return DatalistInput_jsx("div", {
    className: classnames_default()(className, 'relative inline-block isolate w-full')
  }, DatalistInput_jsx("input", Object(esm_extends["a" /* default */])({}, field, {
    "aria-label": "Search",
    autoComplete: "off",
    className: classnames_default()(inputClassName, 'w-full'),
    "data-testid": dataTestId,
    id: field.name,
    onBlur: onHandleBlur,
    onChange: onHandleInput,
    onClick: onClickInput,
    onKeyDown: onHandleKeydown,
    placeholder: placeholder,
    ref: inputField,
    type: "text",
    value: currentInput
  })), dropDown);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/Label.jsx
var Label = __webpack_require__("vJSV");

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/Datalist.jsx














var Datalist_jsx = react_default.a.createElement;

function Datalist_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Datalist_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Datalist_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Datalist_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var Datalist_Datalist = function Datalist(_ref) {
  var className = _ref.className,
      dataTestId = _ref.dataTestId,
      field = _ref.field,
      form = _ref.form,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      label = _ref.label,
      setOrDefault = _ref.setOrDefault,
      options = _ref.options;

  var selectedValue = get_default()(form.values, field.name, '');

  var _getValidationStatus = Object(inputsUtils["e" /* getValidationStatus */])(Datalist_objectSpread(Datalist_objectSpread({}, field), {}, {
    value: selectedValue
  }), form, isDisabled),
      isDefaultState = _getValidationStatus.isDefaultState,
      isErrored = _getValidationStatus.isErrored,
      isValidated = _getValidationStatus.isValidated;

  var classes = Object(inputsUtils["c" /* getInputClasses */])({
    hasHeight: true,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated
  });

  var handleOnSelectOrBlure = function handleOnSelectOrBlure(value) {
    value && form.setFieldValue(field.name, setOrDefault(value));
  };

  return Datalist_jsx(react["Fragment"], null, !!label && Datalist_jsx(Label["a" /* Label */], {
    className: "mb-5 mx-15",
    htmlFor: field.name,
    isErrored: isErrored,
    isRequired: isRequired,
    label: label
  }), Datalist_jsx(DatalistInput_DataListInput, {
    className: className,
    dataTestId: dataTestId,
    field: field,
    inputClassName: classes,
    items: options.map(function (_ref2) {
      var itemLabel = _ref2.label,
          value = _ref2.value;
      return {
        label: itemLabel,
        key: value
      };
    }),
    onSelect: handleOnSelectOrBlure,
    onBlur: handleOnSelectOrBlure
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: ./src/hooks/use-unmount-delay/useUnmountDelay.js
var useUnmountDelay = __webpack_require__("5C2K");

// EXTERNAL MODULE: ./src/client/components/frameworks/datepicker/Datepicker.jsx + 2 modules
var Datepicker = __webpack_require__("Dm6d");

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/DatePickerInput.jsx








var DatePickerInput_jsx = react_default.a.createElement;











if ( true && typeof document !== 'undefined') {
  // $FlowFixMe
  __webpack_require__("mi0r");
}

var clickedElementIs = function clickedElementIs(element, elementType, dataTestId) {
  return element instanceof Element && element.closest(elementType) && // $FlowFixMe element.closest is not null or void
  element.closest(elementType).matches("[data-testid=\"".concat(dataTestId, "\"]"));
};

var DatePickerInput_DatePickerInput = function DatePickerInput(_ref) {
  var className = _ref.className,
      customClasses = _ref.customClasses,
      dataTestId = _ref.dataTestId,
      _ref$dateFormat = _ref.dateFormat,
      dateFormat = _ref$dateFormat === void 0 ? 'DD/MM/YYYY' : _ref$dateFormat,
      _ref$defaultDuration = _ref.defaultDuration,
      defaultDuration = _ref$defaultDuration === void 0 ? 1 : _ref$defaultDuration,
      disabledDays = _ref.disabledDays,
      field = _ref.field,
      form = _ref.form,
      _ref$hasArrowDown = _ref.hasArrowDown,
      hasArrowDown = _ref$hasArrowDown === void 0 ? false : _ref$hasArrowDown,
      _ref$isDateRange = _ref.isDateRange,
      isDateRange = _ref$isDateRange === void 0 ? false : _ref$isDateRange,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      label = _ref.label,
      language = _ref.language,
      maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      placeholder = _ref.placeholder;

  var _useState = Object(react["useState"])(false),
      isActive = _useState[0],
      setIsActive = _useState[1];

  var datePickerReference = Object(react["useRef"])(null);

  var _get2 = get_default()(form.values, field.name, {}),
      from = _get2.from,
      to = _get2.to;

  var fromInputValue = from ? moment_default()(from).format(dateFormat) : null;
  var toInputValue = to ? moment_default()(to).format(dateFormat) : null;
  var inputValue = [fromInputValue, toInputValue].filter(function (value) {
    return !!value;
  }).join(' — ');

  var _getValidationStatus = Object(inputsUtils["e" /* getValidationStatus */])(field, form, isDisabled),
      isDefaultState = _getValidationStatus.isDefaultState,
      isErrored = _getValidationStatus.isErrored,
      isValidated = _getValidationStatus.isValidated; // Open/Close effect


  Object(react["useEffect"])(function () {
    var onClickOutside = function onClickOutside(e) {
      var datePickerElement = datePickerReference.current;
      var clickedElement = e.target;
      var clickedElementIsPrevArrow = clickedElementIs(clickedElement, 'button', 'datepicker-arrow-prev');
      var clickedElementIsNextArrow = clickedElementIs(clickedElement, 'button', 'datepicker-arrow-next');

      if (datePickerElement && !datePickerElement.contains(clickedElement) && !clickedElementIsPrevArrow && !clickedElementIsNextArrow) {
        // 1. Set "to" date based on default duration if it's not defined
        if (isDateRange && !!from && !to) {
          form.setFieldValue(field.name, {
            from: from,
            to: moment_default()(from).add({
              days: defaultDuration
            }).toDate()
          });
        } // 2. Close DatePicker


        setIsActive(false);
      }
    };

    document.addEventListener('click', onClickOutside);
    document.addEventListener('focus', onClickOutside);
    return function () {
      document.removeEventListener('click', onClickOutside);
      document.removeEventListener('focus', onClickOutside);
    };
  }, [from, to]);

  var onDaySelect = function onDaySelect(_ref2) {
    var fromDate = _ref2.fromDate,
        toDate = _ref2.toDate;

    if (isDateRange && !!fromDate && !toDate) {
      form.setFieldValue(field.name, {
        from: fromDate,
        to: moment_default()(fromDate).add({
          days: defaultDuration
        }).toDate()
      });
    } // 2. Close DatePicker


    setIsActive(false);
  };

  var shouldRenderDatePicker = Object(useUnmountDelay["a" /* useDelayUnmount */])(isActive, 300);
  var classes = Object(inputsUtils["c" /* getInputClasses */])({
    hasHeight: true,
    hasValidationStatus: true,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated
  });
  var datePickerStyle = customClasses ? customClasses : classes;
  return DatePickerInput_jsx(react["Fragment"], null, !!label && DatePickerInput_jsx(Label["a" /* Label */], {
    className: "mb-5 mx-15",
    htmlFor: field.name,
    isErrored: isErrored,
    isRequired: isRequired,
    label: label
  }), DatePickerInput_jsx("div", {
    className: classnames_default()(className, 'isolate relative w-full'),
    ref: datePickerReference
  }, DatePickerInput_jsx("div", {
    className: "flex isolate items-center relative w-full"
  }, DatePickerInput_jsx("input", Object(esm_extends["a" /* default */])({
    autoComplete: "off",
    className: datePickerStyle,
    "data-testid": dataTestId,
    disabled: isDisabled
  }, field, {
    onFocus: function onFocus() {
      return setIsActive(true);
    },
    placeholder: placeholder,
    style: {
      height: inputsUtils["a" /* INPUT_HEIGHT */]
    },
    type: "text",
    value: inputValue
  })), hasArrowDown && DatePickerInput_jsx("div", {
    className: "absolute end-0 flex items-center pointer-events-none mx-20"
  }, DatePickerInput_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_DOWN,
    width: ".625rem"
  })), !isDisabled && DatePickerInput_jsx(ImageValidationStatus_ImageValidationStatus, {
    className: classnames_default()('absolute end-0', {
      ' mx-40': hasArrowDown,
      ' mx-20': !hasArrowDown
    }),
    isErrored: isErrored,
    isValidated: isValidated
  })), shouldRenderDatePicker && DatePickerInput_jsx("div", {
    className: classnames_default()('absolute bg-white border-1 border-black left-1/2 min-w-full mt-10 p-10 rounded top-full transform -translate-x-1/2', isActive ? 'fadeIn' : 'fadeOut')
  }, DatePickerInput_jsx(Datepicker["a" /* Datepicker */], {
    field: field,
    form: form,
    isDateRange: isDateRange,
    isFormikInput: true,
    locale: language,
    maxDate: maxDate,
    minDate: minDate,
    disabledDays: disabledDays,
    onSelect: onDaySelect,
    theme: "defaultFormikInput"
  }))));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/Hidden.jsx


var Hidden_jsx = react_default.a.createElement;

var Hidden_Hidden = function Hidden(_ref) {
  var field = _ref.field;
  return Hidden_jsx("input", Object(esm_extends["a" /* default */])({
    id: field.name,
    type: "hidden"
  }, field, {
    // to not trigger a React error when the field is initialize to undefined
    value: field.value || ''
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/Input.jsx
















var Input_jsx = react_default.a.createElement;

function Input_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Input_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Input_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Input_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var Input_Input = function Input(_ref) {
  var air360ClassName = _ref.air360ClassName,
      _ref$autoComplete = _ref.autoComplete,
      autoComplete = _ref$autoComplete === void 0 ? 'off' : _ref$autoComplete,
      _ref$customClasses = _ref.customClasses,
      customClasses = _ref$customClasses === void 0 ? '' : _ref$customClasses,
      customId = _ref.customId,
      dataTestId = _ref.dataTestId,
      field = _ref.field,
      form = _ref.form,
      hideErrorMessage = _ref.hideErrorMessage,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      label = _ref.label,
      labelAdditionalInfo = _ref.labelAdditionalInfo,
      placeholder = _ref.placeholder,
      type = _ref.type,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["air360ClassName", "autoComplete", "customClasses", "customId", "dataTestId", "field", "form", "hideErrorMessage", "isDisabled", "isRequired", "label", "labelAdditionalInfo", "placeholder", "type"]);

  // Input value defaults to empty string
  var value = get_default()(form.values, field.name, '');

  var _getValidationStatus = Object(inputsUtils["e" /* getValidationStatus */])(Input_objectSpread(Input_objectSpread({}, field), {}, {
    value: value
  }), form, isDisabled),
      isDefaultState = _getValidationStatus.isDefaultState,
      isErrored = _getValidationStatus.isErrored,
      isValidated = _getValidationStatus.isValidated;

  var errorNoteId = "error-".concat(kebabCase_default()(field.name));
  var classes = Object(inputsUtils["c" /* getInputClasses */])({
    hasHeight: true,
    hasValidationStatus: true,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated
  });
  var inputStyle = customClasses ? classnames_default()(air360ClassName, customClasses) : classnames_default()(air360ClassName, classes);
  return Input_jsx(react["Fragment"], null, !!label && Input_jsx(Label["a" /* Label */], {
    className: "mb-5 mx-15",
    htmlFor: customId || field.name,
    isErrored: isErrored,
    isRequired: isRequired,
    label: label,
    labelAdditionalInfo: labelAdditionalInfo
  }), Input_jsx("div", {
    className: "flex isolate items-center relative w-full"
  }, Input_jsx("input", Object(esm_extends["a" /* default */])({
    "aria-describedby": errorNoteId,
    "aria-invalid": isErrored,
    "aria-required": isRequired,
    autoComplete: autoComplete,
    className: inputStyle,
    "data-testid": dataTestId,
    disabled: isDisabled,
    id: customId ? customId : field.name,
    type: type
  }, placeholder ? {
    placeholder: placeholder
  } : null, field, {
    // default to '' for prevent react warning on controlled component
    value: value || ''
  }, props)), !isDisabled && Input_jsx(ImageValidationStatus_ImageValidationStatus, {
    className: "absolute end-0 mx-20",
    isErrored: isErrored,
    isValidated: isValidated
  })), !hideErrorMessage && Input_jsx(ErrorNote["a" /* ErrorNote */], {
    className: "mx-15",
    isErrored: isErrored,
    errorMessage: get_default()(form.errors, "".concat(field.name)),
    errorNoteId: errorNoteId
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/formik/formik-input/Radio.jsx
var Radio = __webpack_require__("yWv5");

// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/Select.jsx
















var Select_jsx = react_default.a.createElement;

function Select_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Select_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Select_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Select_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable jsx-a11y/no-onchange */








var Select_Select = function Select(_ref) {
  var _ref$customClasses = _ref.customClasses,
      customClasses = _ref$customClasses === void 0 ? '' : _ref$customClasses,
      dataTestId = _ref.dataTestId,
      field = _ref.field,
      form = _ref.form,
      hideErrorMessage = _ref.hideErrorMessage,
      hideImageValidation = _ref.hideImageValidation,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      label = _ref.label,
      labelAdditionalInfo = _ref.labelAdditionalInfo,
      onChange = _ref.onChange,
      onClick = _ref.onClick,
      options = _ref.options,
      placeholder = _ref.placeholder,
      _ref$withOptionGroup = _ref.withOptionGroup,
      withOptionGroup = _ref$withOptionGroup === void 0 ? false : _ref$withOptionGroup;

  if (!options) {
    throw new Error("Can't use select input type without options props");
  } // Select value defaults to empty string


  var selectedValue = get_default()(form.values, field.name, '');

  var _getValidationStatus = Object(inputsUtils["e" /* getValidationStatus */])(Select_objectSpread(Select_objectSpread({}, field), {}, {
    value: selectedValue
  }), form, isDisabled),
      isDefaultState = _getValidationStatus.isDefaultState,
      isErrored = _getValidationStatus.isErrored,
      isValidated = _getValidationStatus.isValidated;

  var errorNoteId = "error-".concat(kebabCase_default()(field.name));
  var onSelectChange = onChange ? onChange : field.onChange;
  var onSelectClick = onClick ? onClick : field.onClick;
  var classes = Object(inputsUtils["c" /* getInputClasses */])({
    hasHeight: true,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated
  });
  var selectStyle = customClasses ? customClasses : classes;
  return Select_jsx(react["Fragment"], null, !!label && Select_jsx(Label["a" /* Label */], {
    className: "mb-5 mx-15",
    htmlFor: field.name,
    isErrored: isErrored,
    isRequired: isRequired,
    label: label,
    labelAdditionalInfo: labelAdditionalInfo
  }), Select_jsx("div", {
    className: "flex isolate items-center relative w-full"
  }, Select_jsx("select", Object(esm_extends["a" /* default */])({
    "aria-describedby": errorNoteId,
    autoComplete: "off",
    className: classnames_default()(selectStyle, 'pe-40'),
    "data-testid": dataTestId,
    disabled: isDisabled,
    id: field.name
  }, field, {
    onChange: onSelectChange,
    onClick: onSelectClick,
    style: {
      height: inputsUtils["a" /* INPUT_HEIGHT */]
    }
  }), placeholder && Select_jsx("option", {
    value: "",
    disabled: true,
    selected: true
  }, placeholder), withOptionGroup ? options.map(function (_ref2) {
    var groupName = _ref2.groupName,
        groupOptions = _ref2.groupOptions;
    return (groupOptions === null || groupOptions === void 0 ? void 0 : groupOptions.length) && Select_jsx("optgroup", {
      label: groupName,
      key: groupName
    }, groupOptions.map(function (_ref3) {
      var isDisabledOption = _ref3.isDisabled,
          key = _ref3.key,
          name = _ref3.name,
          value = _ref3.value;
      return Select_jsx("option", {
        key: key || value,
        value: value,
        disabled: isDisabledOption
      }, name);
    }));
  }) : options.map(function (_ref4) {
    var isDisabledOption = _ref4.isDisabled,
        key = _ref4.key,
        name = _ref4.name,
        value = _ref4.value;
    return Select_jsx("option", {
      key: key || name + field.name,
      value: value,
      disabled: isDisabledOption
    }, name);
  })), Select_jsx("div", {
    className: "absolute end-0 flex items-center pointer-events-none mx-20"
  }, Select_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_DOWN,
    width: ".625rem"
  })), !isDisabled && !hideImageValidation && Select_jsx(ImageValidationStatus_ImageValidationStatus, {
    className: "absolute end-0 mx-40",
    isErrored: isErrored,
    isValidated: isValidated
  })), !hideErrorMessage && Select_jsx(ErrorNote["a" /* ErrorNote */], {
    className: "mx-15",
    isErrored: isErrored,
    errorMessage: get_default()(form.errors, "".concat(field.name)),
    errorNoteId: errorNoteId
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/formik/formik-input/Textarea.jsx















var Textarea_jsx = react_default.a.createElement;

function Textarea_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Textarea_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Textarea_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Textarea_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var Textarea_Textarea = function Textarea(_ref) {
  var dataTestId = _ref.dataTestId,
      field = _ref.field,
      form = _ref.form,
      hideErrorMessage = _ref.hideErrorMessage,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      label = _ref.label,
      maxLength = _ref.maxLength,
      placeholder = _ref.placeholder;

  // Textarea value defaults to empty string
  var value = get_default()(form.values, field.name, '');

  var _getValidationStatus = Object(inputsUtils["e" /* getValidationStatus */])(Textarea_objectSpread(Textarea_objectSpread({}, field), {}, {
    value: value
  }), form, isDisabled),
      isDefaultState = _getValidationStatus.isDefaultState,
      isErrored = _getValidationStatus.isErrored,
      isValidated = _getValidationStatus.isValidated;

  var errorNoteId = "error-".concat(kebabCase_default()(field.name));
  var classes = Object(inputsUtils["c" /* getInputClasses */])({
    hasRadius: false,
    isDefaultState: isDefaultState,
    isDisabled: isDisabled,
    isErrored: isErrored,
    isValidated: isValidated
  });
  return Textarea_jsx(react["Fragment"], null, !!label && Textarea_jsx(Label["a" /* Label */], {
    className: "mb-5 mx-15",
    htmlFor: field.name,
    isErrored: isErrored,
    isRequired: isRequired,
    label: label
  }), Textarea_jsx("textarea", Object(esm_extends["a" /* default */])({
    "aria-describedby": errorNoteId,
    autoComplete: "off",
    className: classnames_default()(classes, 'rounded-24'),
    "data-testid": dataTestId,
    disabled: isDisabled,
    id: field.name,
    maxLength: maxLength
  }, placeholder ? {
    placeholder: placeholder
  } : null, field, {
    value: value
  })), !hideErrorMessage && Textarea_jsx(ErrorNote["a" /* ErrorNote */], {
    className: "mx-15",
    errorMessage: form.errors[field.name],
    errorNoteId: errorNoteId,
    isErrored: isErrored
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx


var FormikInput_jsx = react_default.a.createElement;
















var FormikInput_getComponentByType = function getComponentByType(type) {
  switch (type) {
    case 'birthdate':
      return DateInput_DateInput;

    case 'checkbox':
      return Checkbox_Checkbox;

    case 'creditCardExpiry':
      return CreditCardExpiryInput_CreditCardExpiryInput;

    case 'datalist':
      return Datalist_Datalist;

    case 'datepicker':
      return DatePickerInput_DatePickerInput;

    case 'hidden':
      return Hidden_Hidden;

    case 'radio':
      return Radio["a" /* Radio */];

    case 'select':
      return Select_Select;

    case 'textarea':
      return Textarea_Textarea;

    default:
      return Input_Input;
  }
};

var requiredValidationRule = Object(inputsUtils["d" /* getValidateFieldFunction */])(lib["mixed"]().transform(function (value) {
  return !!value;
}).oneOf([true]).required());

var FormikInput_getValidateFunction = function getValidateFunction(validate, isRequired, context) {
  var isValidate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (validate) {
    return Object(inputsUtils["d" /* getValidateFieldFunction */])(validate, context);
  }

  if (isValidate) {
    if (isRequired) {
      return requiredValidationRule;
    }
  }

  return undefined;
};

var FormikInput_FormikInput = function FormikInput(_ref) {
  var customId = _ref.customId,
      _ref$hideErrorMessage = _ref.hideErrorMessage,
      hideErrorMessage = _ref$hideErrorMessage === void 0 ? false : _ref$hideErrorMessage,
      _ref$hideDataFromSess = _ref.hideDataFromSessionRecording,
      hideDataFromSessionRecording = _ref$hideDataFromSess === void 0 ? true : _ref$hideDataFromSess,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      _ref$isValidate = _ref.isValidate,
      isValidate = _ref$isValidate === void 0 ? true : _ref$isValidate,
      _ref$optimized = _ref.optimized,
      optimized = _ref$optimized === void 0 ? false : _ref$optimized,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      validate = _ref.validate,
      otherProps = Object(objectWithoutProperties["a" /* default */])(_ref, ["customId", "hideErrorMessage", "hideDataFromSessionRecording", "isRequired", "isValidate", "optimized", "type", "validate"]);

  var context = Object(formik_esm["e" /* useFormikContext */])();
  var FormikField = optimized ? formik_esm["a" /* FastField */] : formik_esm["b" /* Field */];
  var air360ClassName = classnames_default()({
    'air360-replay-ignore': hideDataFromSessionRecording
  });
  var dataCsMask = hideDataFromSessionRecording ? {
    'data-cs-mask': true
  } : undefined;
  return FormikInput_jsx(FormikField, Object(esm_extends["a" /* default */])({
    air360ClassName: air360ClassName,
    component: FormikInput_getComponentByType(type),
    customId: customId,
    hideErrorMessage: hideErrorMessage,
    isRequired: isRequired,
    type: type,
    validate: FormikInput_getValidateFunction(validate, isRequired, context, isValidate) // $FlowFixMe

  }, otherProps, dataCsMask));
};

/***/ }),

/***/ "1vCq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _root_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fw2E");


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("R5gN")(module)))

/***/ }),

/***/ "F0GY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ "TuHz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorNote; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var ErrorNote = function ErrorNote(_ref) {
  var className = _ref.className,
      errorMessage = _ref.errorMessage,
      _ref$errorNoteId = _ref.errorNoteId,
      errorNoteId = _ref$errorNoteId === void 0 ? 'error-note' : _ref$errorNoteId,
      _ref$isErrored = _ref.isErrored,
      isErrored = _ref$isErrored === void 0 ? false : _ref$isErrored;
  return __jsx("div", {
    "aria-live": "assertive",
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'text-12 text-red'),
    id: errorNoteId
  }, isErrored && errorMessage && __jsx("p", {
    className: "pt-5 pb-10"
  }, errorMessage));
};

/***/ }),

/***/ "fw2E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("kq48");


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),

/***/ "hUUf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Legend; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var Legend = function Legend(_ref) {
  var className = _ref.className,
      isRequired = _ref.isRequired,
      label = _ref.label,
      labelAdditionalInfo = _ref.labelAdditionalInfo;
  return __jsx("legend", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'font-bold inline-block text-14 text-black')
  }, label, isRequired && '*', labelAdditionalInfo && __jsx("span", {
    className: "font-normal ms-10 text-12 text-grey"
  }, labelAdditionalInfo));
};

/***/ }),

/***/ "kq48":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq")))

/***/ }),

/***/ "ljKo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FastField; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ Field; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ Form; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ Formik; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ useFormikContext; });

// UNUSED EXPORTS: ErrorMessage, FieldArray, FormikConsumer, FormikContext, FormikProvider, connect, getActiveElement, getIn, insert, isEmptyArray, isEmptyChildren, isFunction, isInputEvent, isInteger, isNaN, isObject, isPromise, isString, move, prepareDataForValidation, replace, setIn, setNestedObjectValues, swap, useField, useFormik, validateYupSchema, withFormik, yupToFormErrors

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-fast-compare/index.js
var react_fast_compare = __webpack_require__("F0GY");
var react_fast_compare_default = /*#__PURE__*/__webpack_require__.n(react_fast_compare);

// CONCATENATED MODULE: /opt/webapp/node_modules/deepmerge/dist/es.js
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ var es = (deepmerge_1);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_baseGetTag.js
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ var _baseGetTag = (objectToString);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ var _overArg = (overArg);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getPrototype.js


/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

/* harmony default export */ var _getPrototype = (getPrototype);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ var lodash_es_isObjectLike = (isObjectLike);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isPlainObject.js




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    isPlainObject_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var isPlainObject_hasOwnProperty = isPlainObject_objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!lodash_es_isObjectLike(value) || _baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = isPlainObject_hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ var lodash_es_isPlainObject = (isPlainObject);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_listCacheClear.js
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ var _listCacheClear = (listCacheClear);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/eq.js
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ var lodash_es_eq = (eq);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_assocIndexOf.js


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (lodash_es_eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ var _assocIndexOf = (assocIndexOf);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_listCacheDelete.js


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ var _listCacheDelete = (listCacheDelete);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_listCacheGet.js


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ var _listCacheGet = (listCacheGet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_listCacheHas.js


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

/* harmony default export */ var _listCacheHas = (listCacheHas);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_listCacheSet.js


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ var _listCacheSet = (listCacheSet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_ListCache.js






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

/* harmony default export */ var _ListCache = (ListCache);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_stackClear.js


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

/* harmony default export */ var _stackClear = (stackClear);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_stackDelete.js
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ var _stackDelete = (stackDelete);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_stackGet.js
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ var _stackGet = (stackGet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_stackHas.js
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ var _stackHas = (stackHas);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getNative.js
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ var _getNative = (getValue);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash-es/_root.js
var _root = __webpack_require__("fw2E");

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_Map.js



/* Built-in method references that are verified to be native. */
var Map = _getNative(_root["a" /* default */], 'Map');

/* harmony default export */ var _Map = (Map);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_nativeCreate.js


/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

/* harmony default export */ var _nativeCreate = (nativeCreate);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_hashClear.js


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

/* harmony default export */ var _hashClear = (hashClear);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_hashDelete.js
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _hashDelete = (hashDelete);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_hashGet.js


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var _hashGet_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashGet_hasOwnProperty = _hashGet_objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return _hashGet_hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ var _hashGet = (hashGet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_hashHas.js


/** Used for built-in method references. */
var _hashHas_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashHas_hasOwnProperty = _hashHas_objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : _hashHas_hasOwnProperty.call(data, key);
}

/* harmony default export */ var _hashHas = (hashHas);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_hashSet.js


/** Used to stand-in for `undefined` hash values. */
var _hashSet_HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? _hashSet_HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ var _hashSet = (hashSet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_Hash.js






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

/* harmony default export */ var _Hash = (Hash);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_mapCacheClear.js




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

/* harmony default export */ var _mapCacheClear = (mapCacheClear);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_isKeyable.js
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ var _isKeyable = (isKeyable);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getMapData.js


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ var _getMapData = (getMapData);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_mapCacheDelete.js


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _mapCacheDelete = (mapCacheDelete);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_mapCacheGet.js


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

/* harmony default export */ var _mapCacheGet = (mapCacheGet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_mapCacheHas.js


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

/* harmony default export */ var _mapCacheHas = (mapCacheHas);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_mapCacheSet.js


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ var _mapCacheSet = (mapCacheSet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_MapCache.js






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

/* harmony default export */ var _MapCache = (MapCache);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_stackSet.js




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ var _stackSet = (stackSet);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_Stack.js







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

/* harmony default export */ var _Stack = (Stack);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_arrayEach.js
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/* harmony default export */ var _arrayEach = (arrayEach);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_defineProperty.js


var defineProperty = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ var _defineProperty = (defineProperty);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_baseAssignValue.js


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty) {
    _defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ var _baseAssignValue = (baseAssignValue);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_assignValue.js



/** Used for built-in method references. */
var _assignValue_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _assignValue_hasOwnProperty = _assignValue_objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(_assignValue_hasOwnProperty.call(object, key) && lodash_es_eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

/* harmony default export */ var _assignValue = (assignValue);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_copyObject.js



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ var _copyObject = (copyObject);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/keys.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

/* harmony default export */ var keys = (nativeKeys);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_baseAssign.js



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && _copyObject(source, keys(source), object);
}

/* harmony default export */ var _baseAssign = (baseAssign);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/keysIn.js
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var keysIn = (nativeKeysIn);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_baseAssignIn.js



/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && _copyObject(source, keysIn(source), object);
}

/* harmony default export */ var _baseAssignIn = (baseAssignIn);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash-es/_cloneBuffer.js
var _cloneBuffer = __webpack_require__("1vCq");

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_copyArray.js
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ var _copyArray = (copyArray);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getSymbols.js
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ var _getSymbols = (stubArray);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_copySymbols.js



/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}

/* harmony default export */ var _copySymbols = (copySymbols);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getSymbolsIn.js
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function _getSymbolsIn_stubArray() {
  return [];
}

/* harmony default export */ var _getSymbolsIn = (_getSymbolsIn_stubArray);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_copySymbolsIn.js



/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}

/* harmony default export */ var _copySymbolsIn = (copySymbolsIn);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getAllKeys.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var _getAllKeys_nativeKeys = _overArg(Object.keys, Object);

/* harmony default export */ var _getAllKeys = (_getAllKeys_nativeKeys);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getAllKeysIn.js
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function _getAllKeysIn_nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _getAllKeysIn = (_getAllKeysIn_nativeKeysIn);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_getTag.js
/** Used for built-in method references. */
var _getTag_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _getTag_nativeObjectToString = _getTag_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function _getTag_objectToString(value) {
  return _getTag_nativeObjectToString.call(value);
}

/* harmony default export */ var _getTag = (_getTag_objectToString);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_initCloneArray.js
/** Used for built-in method references. */
var _initCloneArray_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _initCloneArray_hasOwnProperty = _initCloneArray_objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && _initCloneArray_hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/* harmony default export */ var _initCloneArray = (initCloneArray);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_initCloneByTag.js
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ var _initCloneByTag = (identity);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isObject.js
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ var lodash_es_isObject = (isObject);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_baseCreate.js


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!lodash_es_isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ var _baseCreate = (baseCreate);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_isPrototype.js
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ var _isPrototype = (stubFalse);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_initCloneObject.js




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

/* harmony default export */ var _initCloneObject = (initCloneObject);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isArray.js
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ var lodash_es_isArray = (isArray);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isBuffer.js
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function isBuffer_stubFalse() {
  return false;
}

/* harmony default export */ var isBuffer = (isBuffer_stubFalse);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isMap.js
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function isMap_stubFalse() {
  return false;
}

/* harmony default export */ var isMap = (isMap_stubFalse);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isSet.js
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function isSet_stubFalse() {
  return false;
}

/* harmony default export */ var isSet = (isSet_stubFalse);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_baseClone.js























/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    _baseClone_objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[_baseClone_objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!lodash_es_isObject(value)) {
    return value;
  }
  var isArr = lodash_es_isArray(value);
  if (isArr) {
    result = _initCloneArray(value);
    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return Object(_cloneBuffer["a" /* default */])(value, isDeep);
    }
    if (tag == _baseClone_objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : _initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? _copySymbolsIn(value, _baseAssignIn(result, value))
          : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = _initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new _Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? _getAllKeysIn : _getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  _arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/* harmony default export */ var _baseClone = (baseClone);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/clone.js


/** Used to compose bitmasks for cloning. */
var clone_CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return _baseClone(value, clone_CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ var lodash_es_clone = (clone);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_arrayMap.js
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ var _arrayMap = (arrayMap);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/isSymbol.js
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function isSymbol_stubFalse() {
  return false;
}

/* harmony default export */ var isSymbol = (isSymbol_stubFalse);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/memoize.js


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache;

/* harmony default export */ var lodash_es_memoize = (memoize);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_memoizeCapped.js


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = lodash_es_memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ var _memoizeCapped = (memoizeCapped);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_stringToPath.js


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ var _stringToPath = (stringToPath);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/_toKey.js
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function _toKey_identity(value) {
  return value;
}

/* harmony default export */ var _toKey = (_toKey_identity);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/toString.js
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function toString_identity(value) {
  return value;
}

/* harmony default export */ var lodash_es_toString = (toString_identity);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/toPath.js








/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (lodash_es_isArray(value)) {
    return _arrayMap(value, _toKey);
  }
  return isSymbol(value) ? [value] : _copyArray(_stringToPath(lodash_es_toString(value)));
}

/* harmony default export */ var lodash_es_toPath = (toPath);

// CONCATENATED MODULE: /opt/webapp/node_modules/tiny-warning/dist/tiny-warning.esm.js
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ var tiny_warning_esm = (warning);

// EXTERNAL MODULE: /opt/webapp/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__("oXkQ");
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);

// CONCATENATED MODULE: /opt/webapp/node_modules/lodash-es/cloneDeep.js


/** Used to compose bitmasks for cloning. */
var cloneDeep_CLONE_DEEP_FLAG = 1,
    cloneDeep_CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return _baseClone(value, cloneDeep_CLONE_DEEP_FLAG | cloneDeep_CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ var lodash_es_cloneDeep = (cloneDeep);

// CONCATENATED MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js










function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/** @private is the value an empty array? */

var isEmptyArray = function isEmptyArray(value) {
  return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */

var isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};
/** @private is the given object an Object? */

var formik_esm_isObject = function isObject(obj) {
  return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */

var isInteger = function isInteger(obj) {
  return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */

var isString = function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */
// eslint-disable-next-line no-self-compare

var isNaN$1 = function isNaN(obj) {
  return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */

var formik_esm_isEmptyChildren = function isEmptyChildren(children) {
  return react["Children"].count(children) === 0;
};
/** @private is the given object/value a promise? */

var isPromise = function isPromise(value) {
  return formik_esm_isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */

var isInputEvent = function isInputEvent(value) {
  return value && formik_esm_isObject(value) && formik_esm_isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */

function getActiveElement(doc) {
  doc = doc || (typeof document !== 'undefined' ? document : undefined);

  if (typeof doc === 'undefined') {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}
/**
 * Deeply get a value from an object via its path.
 */

function getIn(obj, key, def, p) {
  if (p === void 0) {
    p = 0;
  }

  var path = lodash_es_toPath(key);

  while (obj && p < path.length) {
    obj = obj[path[p++]];
  }

  return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */

function setIn(obj, path, value) {
  var res = lodash_es_clone(obj); // this keeps inheritance when obj is a class

  var resVal = res;
  var i = 0;
  var pathArray = lodash_es_toPath(path);

  for (; i < pathArray.length - 1; i++) {
    var currentPath = pathArray[i];
    var currentObj = getIn(obj, pathArray.slice(0, i + 1));

    if (currentObj && (formik_esm_isObject(currentObj) || Array.isArray(currentObj))) {
      resVal = resVal[currentPath] = lodash_es_clone(currentObj);
    } else {
      var nextPath = pathArray[i + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  } // Return original object if new value is the same as current


  if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
    return obj;
  }

  if (value === undefined) {
    delete resVal[pathArray[i]];
  } else {
    resVal[pathArray[i]] = value;
  } // If the path array has a single element, the loop did not run.
  // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.


  if (i === 0 && value === undefined) {
    delete res[pathArray[i]];
  }

  return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */

function setNestedObjectValues(object, value, visited, response) {
  if (visited === void 0) {
    visited = new WeakMap();
  }

  if (response === void 0) {
    response = {};
  }

  for (var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];
    var val = object[k];

    if (formik_esm_isObject(val)) {
      if (!visited.get(val)) {
        visited.set(val, true); // In order to keep array values consistent for both dot path  and
        // bracket syntax, we need to check if this is an array so that
        // this will output  { friends: [true] } and not { friends: { "0": true } }

        response[k] = Array.isArray(val) ? [] : {};
        setNestedObjectValues(val, value, visited, response[k]);
      }
    } else {
      response[k] = value;
    }
  }

  return response;
}

var FormikContext = /*#__PURE__*/Object(react["createContext"])(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
  var formik = Object(react["useContext"])(FormikContext);
  !!!formik ?  false ? undefined : tiny_warning_esm(false) : void 0;
  return formik;
}

function formikReducer(state, msg) {
  switch (msg.type) {
    case 'SET_VALUES':
      return _extends({}, state, {
        values: msg.payload
      });

    case 'SET_TOUCHED':
      return _extends({}, state, {
        touched: msg.payload
      });

    case 'SET_ERRORS':
      if (react_fast_compare_default()(state.errors, msg.payload)) {
        return state;
      }

      return _extends({}, state, {
        errors: msg.payload
      });

    case 'SET_STATUS':
      return _extends({}, state, {
        status: msg.payload
      });

    case 'SET_ISSUBMITTING':
      return _extends({}, state, {
        isSubmitting: msg.payload
      });

    case 'SET_ISVALIDATING':
      return _extends({}, state, {
        isValidating: msg.payload
      });

    case 'SET_FIELD_VALUE':
      return _extends({}, state, {
        values: setIn(state.values, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_TOUCHED':
      return _extends({}, state, {
        touched: setIn(state.touched, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_ERROR':
      return _extends({}, state, {
        errors: setIn(state.errors, msg.payload.field, msg.payload.value)
      });

    case 'RESET_FORM':
      return _extends({}, state, msg.payload);

    case 'SET_FORMIK_STATE':
      return msg.payload(state);

    case 'SUBMIT_ATTEMPT':
      return _extends({}, state, {
        touched: setNestedObjectValues(state.values, true),
        isSubmitting: true,
        submitCount: state.submitCount + 1
      });

    case 'SUBMIT_FAILURE':
      return _extends({}, state, {
        isSubmitting: false
      });

    case 'SUBMIT_SUCCESS':
      return _extends({}, state, {
        isSubmitting: false
      });

    default:
      return state;
  }
} // Initial empty states // objects


var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
  var _ref$validateOnChange = _ref.validateOnChange,
      validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange,
      _ref$validateOnBlur = _ref.validateOnBlur,
      validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur,
      _ref$validateOnMount = _ref.validateOnMount,
      validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount,
      isInitialValid = _ref.isInitialValid,
      _ref$enableReinitiali = _ref.enableReinitialize,
      enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali,
      onSubmit = _ref.onSubmit,
      rest = _objectWithoutPropertiesLoose(_ref, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]);

  var props = _extends({
    validateOnChange: validateOnChange,
    validateOnBlur: validateOnBlur,
    validateOnMount: validateOnMount,
    onSubmit: onSubmit
  }, rest);

  var initialValues = Object(react["useRef"])(props.initialValues);
  var initialErrors = Object(react["useRef"])(props.initialErrors || emptyErrors);
  var initialTouched = Object(react["useRef"])(props.initialTouched || emptyTouched);
  var initialStatus = Object(react["useRef"])(props.initialStatus);
  var isMounted = Object(react["useRef"])(false);
  var fieldRegistry = Object(react["useRef"])({});

  if (false) {}

  Object(react["useEffect"])(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);

  var _React$useReducer = Object(react["useReducer"])(formikReducer, {
    values: props.initialValues,
    errors: props.initialErrors || emptyErrors,
    touched: props.initialTouched || emptyTouched,
    status: props.initialStatus,
    isSubmitting: false,
    isValidating: false,
    submitCount: 0
  }),
      state = _React$useReducer[0],
      dispatch = _React$useReducer[1];

  var runValidateHandler = Object(react["useCallback"])(function (values, field) {
    return new Promise(function (resolve, reject) {
      var maybePromisedErrors = props.validate(values, field);

      if (maybePromisedErrors == null) {
        // use loose null check here on purpose
        resolve(emptyErrors);
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(function (errors) {
          resolve(errors || emptyErrors);
        }, function (actualException) {
          if (false) {}

          reject(actualException);
        });
      } else {
        resolve(maybePromisedErrors);
      }
    });
  }, [props.validate]);
  /**
   * Run validation against a Yup schema and optionally run a function if successful
   */

  var runValidationSchema = Object(react["useCallback"])(function (values, field) {
    var validationSchema = props.validationSchema;
    var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
    var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
    return new Promise(function (resolve, reject) {
      promise.then(function () {
        resolve(emptyErrors);
      }, function (err) {
        // Yup will throw a validation error if validation fails. We catch those and
        // resolve them into Formik errors. We can sniff if something is a Yup error
        // by checking error.name.
        // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
        if (err.name === 'ValidationError') {
          resolve(yupToFormErrors(err));
        } else {
          // We throw any other errors
          if (false) {}

          reject(err);
        }
      });
    });
  }, [props.validationSchema]);
  var runSingleFieldLevelValidation = Object(react["useCallback"])(function (field, value) {
    return new Promise(function (resolve) {
      return resolve(fieldRegistry.current[field].validate(value));
    });
  }, []);
  var runFieldLevelValidations = Object(react["useCallback"])(function (values) {
    var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function (f) {
      return isFunction(fieldRegistry.current[f].validate);
    }); // Construct an array with all of the field validation functions

    var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function (f) {
      return runSingleFieldLevelValidation(f, getIn(values, f));
    }) : [Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')]; // use special case ;)

    return Promise.all(fieldValidations).then(function (fieldErrorsList) {
      return fieldErrorsList.reduce(function (prev, curr, index) {
        if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') {
          return prev;
        }

        if (curr) {
          prev = setIn(prev, fieldKeysWithValidation[index], curr);
        }

        return prev;
      }, {});
    });
  }, [runSingleFieldLevelValidation]); // Run all validations and return the result

  var runAllValidations = Object(react["useCallback"])(function (values) {
    return Promise.all([runFieldLevelValidations(values), props.validationSchema ? runValidationSchema(values) : {}, props.validate ? runValidateHandler(values) : {}]).then(function (_ref2) {
      var fieldErrors = _ref2[0],
          schemaErrors = _ref2[1],
          validateErrors = _ref2[2];
      var combinedErrors = es.all([fieldErrors, schemaErrors, validateErrors], {
        arrayMerge: arrayMerge
      });
      return combinedErrors;
    });
  }, [props.validate, props.validationSchema, runFieldLevelValidations, runValidateHandler, runValidationSchema]); // Run all validations methods and update state accordingly

  var validateFormWithHighPriority = useEventCallback(function (values) {
    if (values === void 0) {
      values = state.values;
    }

    dispatch({
      type: 'SET_ISVALIDATING',
      payload: true
    });
    return runAllValidations(values).then(function (combinedErrors) {
      if (!!isMounted.current) {
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
        dispatch({
          type: 'SET_ERRORS',
          payload: combinedErrors
        });
      }

      return combinedErrors;
    });
  });
  Object(react["useEffect"])(function () {
    if (validateOnMount && isMounted.current === true && react_fast_compare_default()(initialValues.current, props.initialValues)) {
      validateFormWithHighPriority(initialValues.current);
    }
  }, [validateOnMount, validateFormWithHighPriority]);
  var resetForm = Object(react["useCallback"])(function (nextState) {
    var values = nextState && nextState.values ? nextState.values : initialValues.current;
    var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
    var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
    var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
    initialValues.current = values;
    initialErrors.current = errors;
    initialTouched.current = touched;
    initialStatus.current = status;

    var dispatchFn = function dispatchFn() {
      dispatch({
        type: 'RESET_FORM',
        payload: {
          isSubmitting: !!nextState && !!nextState.isSubmitting,
          errors: errors,
          touched: touched,
          status: status,
          values: values,
          isValidating: !!nextState && !!nextState.isValidating,
          submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
        }
      });
    };

    if (props.onReset) {
      var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);

      if (isPromise(maybePromisedOnReset)) {
        maybePromisedOnReset.then(dispatchFn);
      } else {
        dispatchFn();
      }
    } else {
      dispatchFn();
    }
  }, [props.initialErrors, props.initialStatus, props.initialTouched]);
  Object(react["useEffect"])(function () {
    if (isMounted.current === true && !react_fast_compare_default()(initialValues.current, props.initialValues)) {
      if (enableReinitialize) {
        initialValues.current = props.initialValues;
        resetForm();
      }

      if (validateOnMount) {
        validateFormWithHighPriority(initialValues.current);
      }
    }
  }, [enableReinitialize, props.initialValues, resetForm, validateOnMount, validateFormWithHighPriority]);
  Object(react["useEffect"])(function () {
    if (enableReinitialize && isMounted.current === true && !react_fast_compare_default()(initialErrors.current, props.initialErrors)) {
      initialErrors.current = props.initialErrors || emptyErrors;
      dispatch({
        type: 'SET_ERRORS',
        payload: props.initialErrors || emptyErrors
      });
    }
  }, [enableReinitialize, props.initialErrors]);
  Object(react["useEffect"])(function () {
    if (enableReinitialize && isMounted.current === true && !react_fast_compare_default()(initialTouched.current, props.initialTouched)) {
      initialTouched.current = props.initialTouched || emptyTouched;
      dispatch({
        type: 'SET_TOUCHED',
        payload: props.initialTouched || emptyTouched
      });
    }
  }, [enableReinitialize, props.initialTouched]);
  Object(react["useEffect"])(function () {
    if (enableReinitialize && isMounted.current === true && !react_fast_compare_default()(initialStatus.current, props.initialStatus)) {
      initialStatus.current = props.initialStatus;
      dispatch({
        type: 'SET_STATUS',
        payload: props.initialStatus
      });
    }
  }, [enableReinitialize, props.initialStatus, props.initialTouched]);
  var validateField = useEventCallback(function (name) {
    // This will efficiently validate a single field by avoiding state
    // changes if the validation function is synchronous. It's different from
    // what is called when using validateForm.
    if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
      var value = getIn(state.values, name);
      var maybePromise = fieldRegistry.current[name].validate(value);

      if (isPromise(maybePromise)) {
        // Only flip isValidating if the function is async.
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: true
        });
        return maybePromise.then(function (x) {
          return x;
        }).then(function (error) {
          dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
              field: name,
              value: error
            }
          });
          dispatch({
            type: 'SET_ISVALIDATING',
            payload: false
          });
        });
      } else {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: maybePromise
          }
        });
        return Promise.resolve(maybePromise);
      }
    } else if (props.validationSchema) {
      dispatch({
        type: 'SET_ISVALIDATING',
        payload: true
      });
      return runValidationSchema(state.values, name).then(function (x) {
        return x;
      }).then(function (error) {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: error[name]
          }
        });
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
      });
    }

    return Promise.resolve();
  });
  var registerField = Object(react["useCallback"])(function (name, _ref3) {
    var validate = _ref3.validate;
    fieldRegistry.current[name] = {
      validate: validate
    };
  }, []);
  var unregisterField = Object(react["useCallback"])(function (name) {
    delete fieldRegistry.current[name];
  }, []);
  var setTouched = useEventCallback(function (touched, shouldValidate) {
    dispatch({
      type: 'SET_TOUCHED',
      payload: touched
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var setErrors = Object(react["useCallback"])(function (errors) {
    dispatch({
      type: 'SET_ERRORS',
      payload: errors
    });
  }, []);
  var setValues = useEventCallback(function (values, shouldValidate) {
    var resolvedValues = isFunction(values) ? values(state.values) : values;
    dispatch({
      type: 'SET_VALUES',
      payload: resolvedValues
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
  });
  var setFieldError = Object(react["useCallback"])(function (field, value) {
    dispatch({
      type: 'SET_FIELD_ERROR',
      payload: {
        field: field,
        value: value
      }
    });
  }, []);
  var setFieldValue = useEventCallback(function (field, value, shouldValidate) {
    dispatch({
      type: 'SET_FIELD_VALUE',
      payload: {
        field: field,
        value: value
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
  });
  var executeChange = Object(react["useCallback"])(function (eventOrTextValue, maybePath) {
    // By default, assume that the first argument is a string. This allows us to use
    // handleChange with React Native and React Native Web's onChangeText prop which
    // provides just the value of the input.
    var field = maybePath;
    var val = eventOrTextValue;
    var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
    // so we handle like we would a normal HTML change event.

    if (!isString(eventOrTextValue)) {
      // If we can, persist the event
      // @see https://reactjs.org/docs/events.html#event-pooling
      if (eventOrTextValue.persist) {
        eventOrTextValue.persist();
      }

      var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
      var type = target.type,
          name = target.name,
          id = target.id,
          value = target.value,
          checked = target.checked,
          outerHTML = target.outerHTML,
          options = target.options,
          multiple = target.multiple;
      field = maybePath ? maybePath : name ? name : id;

      if (!field && "production" !== "production") {
        warnAboutMissingIdentifier({
          htmlContent: outerHTML,
          documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
          handlerName: 'handleChange'
        });
      }

      val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
      ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
      ? getSelectedValues(options) : value;
    }

    if (field) {
      // Set form fields by name
      setFieldValue(field, val);
    }
  }, [setFieldValue, state.values]);
  var handleChange = useEventCallback(function (eventOrPath) {
    if (isString(eventOrPath)) {
      return function (event) {
        return executeChange(event, eventOrPath);
      };
    } else {
      executeChange(eventOrPath);
    }
  });
  var setFieldTouched = useEventCallback(function (field, touched, shouldValidate) {
    if (touched === void 0) {
      touched = true;
    }

    dispatch({
      type: 'SET_FIELD_TOUCHED',
      payload: {
        field: field,
        value: touched
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var executeBlur = Object(react["useCallback"])(function (e, path) {
    if (e.persist) {
      e.persist();
    }

    var _e$target = e.target,
        name = _e$target.name,
        id = _e$target.id,
        outerHTML = _e$target.outerHTML;
    var field = path ? path : name ? name : id;

    if (!field && "production" !== "production") {
      warnAboutMissingIdentifier({
        htmlContent: outerHTML,
        documentationAnchorLink: 'handleblur-e-any--void',
        handlerName: 'handleBlur'
      });
    }

    setFieldTouched(field, true);
  }, [setFieldTouched]);
  var handleBlur = useEventCallback(function (eventOrString) {
    if (isString(eventOrString)) {
      return function (event) {
        return executeBlur(event, eventOrString);
      };
    } else {
      executeBlur(eventOrString);
    }
  });
  var setFormikState = Object(react["useCallback"])(function (stateOrCb) {
    if (isFunction(stateOrCb)) {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: stateOrCb
      });
    } else {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: function payload() {
          return stateOrCb;
        }
      });
    }
  }, []);
  var setStatus = Object(react["useCallback"])(function (status) {
    dispatch({
      type: 'SET_STATUS',
      payload: status
    });
  }, []);
  var setSubmitting = Object(react["useCallback"])(function (isSubmitting) {
    dispatch({
      type: 'SET_ISSUBMITTING',
      payload: isSubmitting
    });
  }, []);
  var submitForm = useEventCallback(function () {
    dispatch({
      type: 'SUBMIT_ATTEMPT'
    });
    return validateFormWithHighPriority().then(function (combinedErrors) {
      // In case an error was thrown and passed to the resolved Promise,
      // `combinedErrors` can be an instance of an Error. We need to check
      // that and abort the submit.
      // If we don't do that, calling `Object.keys(new Error())` yields an
      // empty array, which causes the validation to pass and the form
      // to be submitted.
      var isInstanceOfError = combinedErrors instanceof Error;
      var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;

      if (isActuallyValid) {
        // Proceed with submit...
        //
        // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
        // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
        // This would be fine in simple cases, but make it impossible to disable submit
        // buttons where people use callbacks or promises as side effects (which is basically
        // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
        //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
        // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
        // cleanup of isSubmitting on behalf of the consumer.
        var promiseOrUndefined;

        try {
          promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
          // via setSubmitting(false)

          if (promiseOrUndefined === undefined) {
            return;
          }
        } catch (error) {
          throw error;
        }

        return Promise.resolve(promiseOrUndefined).then(function (result) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_SUCCESS'
            });
          }

          return result;
        })["catch"](function (_errors) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_FAILURE'
            }); // This is a legit error rejected by the onSubmit fn
            // so we don't want to break the promise chain

            throw _errors;
          }
        });
      } else if (!!isMounted.current) {
        // ^^^ Make sure Formik is still mounted before updating state
        dispatch({
          type: 'SUBMIT_FAILURE'
        }); // throw combinedErrors;

        if (isInstanceOfError) {
          throw combinedErrors;
        }
      }

      return;
    });
  });
  var handleSubmit = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    } // Warn if form submission is triggered by a <button> without a
    // specified `type` attribute during development. This mitigates
    // a common gotcha in forms with both reset and submit buttons,
    // where the dev forgets to add type="button" to the reset button.


    if (false) { var activeElement; }

    submitForm()["catch"](function (reason) {
      console.warn("Warning: An unhandled error was caught from submitForm()", reason);
    });
  });
  var imperativeMethods = {
    resetForm: resetForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    setErrors: setErrors,
    setFieldError: setFieldError,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    setFormikState: setFormikState,
    submitForm: submitForm
  };
  var executeSubmit = useEventCallback(function () {
    return onSubmit(state.values, imperativeMethods);
  });
  var handleReset = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    }

    resetForm();
  });
  var getFieldMeta = Object(react["useCallback"])(function (name) {
    return {
      value: getIn(state.values, name),
      error: getIn(state.errors, name),
      touched: !!getIn(state.touched, name),
      initialValue: getIn(initialValues.current, name),
      initialTouched: !!getIn(initialTouched.current, name),
      initialError: getIn(initialErrors.current, name)
    };
  }, [state.errors, state.touched, state.values]);
  var getFieldHelpers = Object(react["useCallback"])(function (name) {
    return {
      setValue: function setValue(value, shouldValidate) {
        return setFieldValue(name, value, shouldValidate);
      },
      setTouched: function setTouched(value, shouldValidate) {
        return setFieldTouched(name, value, shouldValidate);
      },
      setError: function setError(value) {
        return setFieldError(name, value);
      }
    };
  }, [setFieldValue, setFieldTouched, setFieldError]);
  var getFieldProps = Object(react["useCallback"])(function (nameOrOptions) {
    var isAnObject = formik_esm_isObject(nameOrOptions);
    var name = isAnObject ? nameOrOptions.name : nameOrOptions;
    var valueState = getIn(state.values, name);
    var field = {
      name: name,
      value: valueState,
      onChange: handleChange,
      onBlur: handleBlur
    };

    if (isAnObject) {
      var type = nameOrOptions.type,
          valueProp = nameOrOptions.value,
          is = nameOrOptions.as,
          multiple = nameOrOptions.multiple;

      if (type === 'checkbox') {
        if (valueProp === undefined) {
          field.checked = !!valueState;
        } else {
          field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
          field.value = valueProp;
        }
      } else if (type === 'radio') {
        field.checked = valueState === valueProp;
        field.value = valueProp;
      } else if (is === 'select' && multiple) {
        field.value = field.value || [];
        field.multiple = true;
      }
    }

    return field;
  }, [handleBlur, handleChange, state.values]);
  var dirty = Object(react["useMemo"])(function () {
    return !react_fast_compare_default()(initialValues.current, state.values);
  }, [initialValues.current, state.values]);
  var isValid = Object(react["useMemo"])(function () {
    return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
  }, [isInitialValid, dirty, state.errors, props]);

  var ctx = _extends({}, state, {
    initialValues: initialValues.current,
    initialErrors: initialErrors.current,
    initialTouched: initialTouched.current,
    initialStatus: initialStatus.current,
    handleBlur: handleBlur,
    handleChange: handleChange,
    handleReset: handleReset,
    handleSubmit: handleSubmit,
    resetForm: resetForm,
    setErrors: setErrors,
    setFormikState: setFormikState,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setFieldError: setFieldError,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    submitForm: submitForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    isValid: isValid,
    dirty: dirty,
    unregisterField: unregisterField,
    registerField: registerField,
    getFieldProps: getFieldProps,
    getFieldMeta: getFieldMeta,
    getFieldHelpers: getFieldHelpers,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    validateOnMount: validateOnMount
  });

  return ctx;
}
function Formik(props) {
  var formikbag = useFormik(props);
  var component = props.component,
      children = props.children,
      render = props.render,
      innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />

  Object(react["useImperativeHandle"])(innerRef, function () {
    return formikbag;
  });

  if (false) {}

  return Object(react["createElement"])(FormikProvider, {
    value: formikbag
  }, component ? Object(react["createElement"])(component, formikbag) : render ? render(formikbag) : children // children come last, always called
  ? isFunction(children) ? children(formikbag) : !formik_esm_isEmptyChildren(children) ? react["Children"].only(children) : null : null);
}

function warnAboutMissingIdentifier(_ref4) {
  var htmlContent = _ref4.htmlContent,
      documentationAnchorLink = _ref4.documentationAnchorLink,
      handlerName = _ref4.handlerName;
  console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */


function yupToFormErrors(yupError) {
  var errors = {};

  if (yupError.inner) {
    if (yupError.inner.length === 0) {
      return setIn(errors, yupError.path, yupError.message);
    }

    for (var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref5 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref5 = _i.value;
      }

      var err = _ref5;

      if (!getIn(errors, err.path)) {
        errors = setIn(errors, err.path, err.message);
      }
    }
  }

  return errors;
}
/**
 * Validate a yup schema.
 */

function validateYupSchema(values, schema, sync, context) {
  if (sync === void 0) {
    sync = false;
  }

  if (context === void 0) {
    context = {};
  }

  var validateData = prepareDataForValidation(values);
  return schema[sync ? 'validateSync' : 'validate'](validateData, {
    abortEarly: false,
    context: context
  });
}
/**
 * Recursively prepare values.
 */

function prepareDataForValidation(values) {
  var data = Array.isArray(values) ? [] : {};

  for (var k in values) {
    if (Object.prototype.hasOwnProperty.call(values, k)) {
      var key = String(k);

      if (Array.isArray(values[key]) === true) {
        data[key] = values[key].map(function (value) {
          if (Array.isArray(value) === true || lodash_es_isPlainObject(value)) {
            return prepareDataForValidation(value);
          } else {
            return value !== '' ? value : undefined;
          }
        });
      } else if (lodash_es_isPlainObject(values[key])) {
        data[key] = prepareDataForValidation(values[key]);
      } else {
        data[key] = values[key] !== '' ? values[key] : undefined;
      }
    }
  }

  return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */

function arrayMerge(target, source, options) {
  var destination = target.slice();
  source.forEach(function merge(e, i) {
    if (typeof destination[i] === 'undefined') {
      var cloneRequested = options.clone !== false;
      var shouldClone = cloneRequested && options.isMergeableObject(e);
      destination[i] = shouldClone ? es(Array.isArray(e) ? [] : {}, e, options) : e;
    } else if (options.isMergeableObject(e)) {
      destination[i] = es(target[i], e, options);
    } else if (target.indexOf(e) === -1) {
      destination.push(e);
    }
  });
  return destination;
}
/** Return multi select values based on an array of options */


function getSelectedValues(options) {
  return Array.from(options).filter(function (el) {
    return el.selected;
  }).map(function (el) {
    return el.value;
  });
}
/** Return the next value for a checkbox */


function getValueForCheckbox(currentValue, checked, valueProp) {
  // If the current value was a boolean, return a boolean
  if (typeof currentValue === 'boolean') {
    return Boolean(checked);
  } // If the currentValue was not a boolean we want to return an array


  var currentArrayOfValues = [];
  var isValueInArray = false;
  var index = -1;

  if (!Array.isArray(currentValue)) {
    // eslint-disable-next-line eqeqeq
    if (!valueProp || valueProp == 'true' || valueProp == 'false') {
      return Boolean(checked);
    }
  } else {
    // If the current value is already an array, use it
    currentArrayOfValues = currentValue;
    index = currentValue.indexOf(valueProp);
    isValueInArray = index >= 0;
  } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values


  if (checked && valueProp && !isValueInArray) {
    return currentArrayOfValues.concat(valueProp);
  } // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values


  if (!isValueInArray) {
    return currentArrayOfValues;
  } // If the checkbox was unchecked and the value is in the array, remove the value and return the array


  return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85


var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react["useLayoutEffect"] : react["useEffect"];

function useEventCallback(fn) {
  var ref = Object(react["useRef"])(fn); // we copy a ref to the callback scoped to the current state/props on each render

  useIsomorphicLayoutEffect(function () {
    ref.current = fn;
  });
  return Object(react["useCallback"])(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ref.current.apply(void 0, args);
  }, []);
}

function useField(propsOrFieldName) {
  var formik = useFormikContext();
  var getFieldProps = formik.getFieldProps,
      getFieldMeta = formik.getFieldMeta,
      getFieldHelpers = formik.getFieldHelpers,
      registerField = formik.registerField,
      unregisterField = formik.unregisterField;
  var isAnObject = formik_esm_isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>

  var props = isAnObject ? propsOrFieldName : {
    name: propsOrFieldName
  };
  var fieldName = props.name,
      validateFn = props.validate;
  Object(react["useEffect"])(function () {
    if (fieldName) {
      registerField(fieldName, {
        validate: validateFn
      });
    }

    return function () {
      if (fieldName) {
        unregisterField(fieldName);
      }
    };
  }, [registerField, unregisterField, fieldName, validateFn]);

  if (false) {}

  !fieldName ?  false ? undefined : tiny_warning_esm(false) : void 0;
  return [getFieldProps(props), getFieldMeta(fieldName), getFieldHelpers(fieldName)];
}
function Field(_ref) {
  var validate = _ref.validate,
      name = _ref.name,
      render = _ref.render,
      children = _ref.children,
      is = _ref.as,
      component = _ref.component,
      props = _objectWithoutPropertiesLoose(_ref, ["validate", "name", "render", "children", "as", "component"]);

  var _useFormikContext = useFormikContext(),
      formik = _objectWithoutPropertiesLoose(_useFormikContext, ["validate", "validationSchema"]);

  if (false) {} // Register field and field-level validation with parent <Formik>


  var registerField = formik.registerField,
      unregisterField = formik.unregisterField;
  Object(react["useEffect"])(function () {
    registerField(name, {
      validate: validate
    });
    return function () {
      unregisterField(name);
    };
  }, [registerField, unregisterField, name, validate]);
  var field = formik.getFieldProps(_extends({
    name: name
  }, props));
  var meta = formik.getFieldMeta(name);
  var legacyBag = {
    field: field,
    form: formik
  };

  if (render) {
    return render(_extends({}, legacyBag, {
      meta: meta
    }));
  }

  if (isFunction(children)) {
    return children(_extends({}, legacyBag, {
      meta: meta
    }));
  }

  if (component) {
    // This behavior is backwards compat with earlier Formik 0.9 to 1.x
    if (typeof component === 'string') {
      var innerRef = props.innerRef,
          rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

      return Object(react["createElement"])(component, _extends({
        ref: innerRef
      }, field, rest), children);
    } // We don't pass `meta` for backwards compat


    return Object(react["createElement"])(component, _extends({
      field: field,
      form: formik
    }, props), children);
  } // default to input here so we can check for both `as` and `children` above


  var asElement = is || 'input';

  if (typeof asElement === 'string') {
    var _innerRef = props.innerRef,
        _rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

    return Object(react["createElement"])(asElement, _extends({
      ref: _innerRef
    }, field, _rest), children);
  }

  return Object(react["createElement"])(asElement, _extends({}, field, props), children);
}

var Form = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
  // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
  var action = props.action,
      rest = _objectWithoutPropertiesLoose(props, ["action"]);

  var _action = action != null ? action : '#';

  var _useFormikContext = useFormikContext(),
      handleReset = _useFormikContext.handleReset,
      handleSubmit = _useFormikContext.handleSubmit;

  return Object(react["createElement"])("form", Object.assign({
    onSubmit: handleSubmit,
    ref: ref,
    onReset: handleReset,
    action: _action
  }, rest));
});
Form.displayName = 'Form';

/**
 * A public higher-order component to access the imperative API
 */

function withFormik(_ref) {
  var _ref$mapPropsToValues = _ref.mapPropsToValues,
      mapPropsToValues = _ref$mapPropsToValues === void 0 ? function (vanillaProps) {
    var val = {};

    for (var k in vanillaProps) {
      if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') {
        // @todo TypeScript fix
        val[k] = vanillaProps[k];
      }
    }

    return val;
  } : _ref$mapPropsToValues,
      config = _objectWithoutPropertiesLoose(_ref, ["mapPropsToValues"]);

  return function createFormik(Component$1) {
    var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
    /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */

    var C = /*#__PURE__*/function (_React$Component) {
      _inheritsLoose(C, _React$Component);

      function C() {
        var _this;

        _this = _React$Component.apply(this, arguments) || this;

        _this.validate = function (values) {
          return config.validate(values, _this.props);
        };

        _this.validationSchema = function () {
          return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
        };

        _this.handleSubmit = function (values, actions) {
          return config.handleSubmit(values, _extends({}, actions, {
            props: _this.props
          }));
        };
        /**
         * Just avoiding a render callback for perf here
         */


        _this.renderFormComponent = function (formikProps) {
          return Object(react["createElement"])(Component$1, Object.assign({}, _this.props, formikProps));
        };

        return _this;
      }

      var _proto = C.prototype;

      _proto.render = function render() {
        var _this$props = this.props,
            props = _objectWithoutPropertiesLoose(_this$props, ["children"]);

        return Object(react["createElement"])(Formik, Object.assign({}, props, config, {
          validate: config.validate && this.validate,
          validationSchema: config.validationSchema && this.validationSchema,
          initialValues: mapPropsToValues(this.props),
          initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
          initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
          initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
          onSubmit: this.handleSubmit,
          children: this.renderFormComponent
        }));
      };

      return C;
    }(react["Component"]);

    C.displayName = "WithFormik(" + componentDisplayName + ")";
    return hoist_non_react_statics_cjs_default()(C, Component$1 // cast type to ComponentClass (even if SFC)
    );
  };
}

/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */

function connect(Comp) {
  var C = function C(props) {
    return Object(react["createElement"])(FormikConsumer, null, function (formik) {
      !!!formik ?  false ? undefined : tiny_warning_esm(false) : void 0;
      return Object(react["createElement"])(Comp, Object.assign({}, props, {
        formik: formik
      }));
    });
  };

  var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
  // For example, <Field.WrappedComponent /> gets us <FieldInner/>

  C.WrappedComponent = Comp;
  C.displayName = "FormikConnect(" + componentDisplayName + ")";
  return hoist_non_react_statics_cjs_default()(C, Comp // cast type to ComponentClass (even if SFC)
  );
}

/**
 * Some array helpers!
 */

var move = function move(array, from, to) {
  var copy = copyArrayLike(array);
  var value = copy[from];
  copy.splice(from, 1);
  copy.splice(to, 0, value);
  return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
  var copy = copyArrayLike(arrayLike);
  var a = copy[indexA];
  copy[indexA] = copy[indexB];
  copy[indexB] = a;
  return copy;
};
var insert = function insert(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy.splice(index, 0, value);
  return copy;
};
var replace = function replace(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy[index] = value;
  return copy;
};

var copyArrayLike = function copyArrayLike(arrayLike) {
  if (!arrayLike) {
    return [];
  } else if (Array.isArray(arrayLike)) {
    return [].concat(arrayLike);
  } else {
    var maxIndex = Object.keys(arrayLike).map(function (key) {
      return parseInt(key);
    }).reduce(function (max, el) {
      return el > max ? el : max;
    }, 0);
    return Array.from(_extends({}, arrayLike, {
      length: maxIndex + 1
    }));
  }
};

var formik_esm_FieldArrayInner = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FieldArrayInner, _React$Component);

  function FieldArrayInner(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.updateArrayField = function (fn, alterTouched, alterErrors) {
      var _this$props = _this.props,
          name = _this$props.name,
          setFormikState = _this$props.formik.setFormikState;
      setFormikState(function (prevState) {
        var updateErrors = typeof alterErrors === 'function' ? alterErrors : fn;
        var updateTouched = typeof alterTouched === 'function' ? alterTouched : fn; // values fn should be executed before updateErrors and updateTouched,
        // otherwise it causes an error with unshift.

        var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
        var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
        var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;

        if (isEmptyArray(fieldError)) {
          fieldError = undefined;
        }

        if (isEmptyArray(fieldTouched)) {
          fieldTouched = undefined;
        }

        return _extends({}, prevState, {
          values: values,
          errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
          touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
        });
      });
    };

    _this.push = function (value) {
      return _this.updateArrayField(function (arrayLike) {
        return [].concat(copyArrayLike(arrayLike), [lodash_es_cloneDeep(value)]);
      }, false, false);
    };

    _this.handlePush = function (value) {
      return function () {
        return _this.push(value);
      };
    };

    _this.swap = function (indexA, indexB) {
      return _this.updateArrayField(function (array) {
        return swap(array, indexA, indexB);
      }, true, true);
    };

    _this.handleSwap = function (indexA, indexB) {
      return function () {
        return _this.swap(indexA, indexB);
      };
    };

    _this.move = function (from, to) {
      return _this.updateArrayField(function (array) {
        return move(array, from, to);
      }, true, true);
    };

    _this.handleMove = function (from, to) {
      return function () {
        return _this.move(from, to);
      };
    };

    _this.insert = function (index, value) {
      return _this.updateArrayField(function (array) {
        return insert(array, index, value);
      }, function (array) {
        return insert(array, index, null);
      }, function (array) {
        return insert(array, index, null);
      });
    };

    _this.handleInsert = function (index, value) {
      return function () {
        return _this.insert(index, value);
      };
    };

    _this.replace = function (index, value) {
      return _this.updateArrayField(function (array) {
        return replace(array, index, value);
      }, false, false);
    };

    _this.handleReplace = function (index, value) {
      return function () {
        return _this.replace(index, value);
      };
    };

    _this.unshift = function (value) {
      var length = -1;

      _this.updateArrayField(function (array) {
        var arr = array ? [value].concat(array) : [value];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      });

      return length;
    };

    _this.handleUnshift = function (value) {
      return function () {
        return _this.unshift(value);
      };
    };

    _this.handleRemove = function (index) {
      return function () {
        return _this.remove(index);
      };
    };

    _this.handlePop = function () {
      return function () {
        return _this.pop();
      };
    }; // We need TypeScript generics on these, so we'll bind them in the constructor
    // @todo Fix TS 3.2.1


    _this.remove = _this.remove.bind(_assertThisInitialized(_this));
    _this.pop = _this.pop.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = FieldArrayInner.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.validateOnChange && this.props.formik.validateOnChange && !react_fast_compare_default()(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) {
      this.props.formik.validateForm(this.props.formik.values);
    }
  };

  _proto.remove = function remove(index) {
    // We need to make sure we also remove relevant pieces of `touched` and `errors`
    var result;
    this.updateArrayField( // so this gets call 3 times
    function (array) {
      var copy = array ? copyArrayLike(array) : [];

      if (!result) {
        result = copy[index];
      }

      if (isFunction(copy.splice)) {
        copy.splice(index, 1);
      }

      return copy;
    }, true, true);
    return result;
  };

  _proto.pop = function pop() {
    // Remove relevant pieces of `touched` and `errors` too!
    var result;
    this.updateArrayField( // so this gets call 3 times
    function (array) {
      var tmp = array;

      if (!result) {
        result = tmp && tmp.pop && tmp.pop();
      }

      return tmp;
    }, true, true);
    return result;
  };

  _proto.render = function render() {
    var arrayHelpers = {
      push: this.push,
      pop: this.pop,
      swap: this.swap,
      move: this.move,
      insert: this.insert,
      replace: this.replace,
      unshift: this.unshift,
      remove: this.remove,
      handlePush: this.handlePush,
      handlePop: this.handlePop,
      handleSwap: this.handleSwap,
      handleMove: this.handleMove,
      handleInsert: this.handleInsert,
      handleReplace: this.handleReplace,
      handleUnshift: this.handleUnshift,
      handleRemove: this.handleRemove
    };

    var _this$props2 = this.props,
        component = _this$props2.component,
        render = _this$props2.render,
        children = _this$props2.children,
        name = _this$props2.name,
        _this$props2$formik = _this$props2.formik,
        restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, ["validate", "validationSchema"]);

    var props = _extends({}, arrayHelpers, {
      form: restOfFormik,
      name: name
    });

    return component ? Object(react["createElement"])(component, props) : render ? render(props) : children // children come last, always called
    ? typeof children === 'function' ? children(props) : !formik_esm_isEmptyChildren(children) ? react["Children"].only(children) : null : null;
  };

  return FieldArrayInner;
}(react["Component"]);

formik_esm_FieldArrayInner.defaultProps = {
  validateOnChange: true
};
var FieldArray = /*#__PURE__*/connect(formik_esm_FieldArrayInner);

var formik_esm_ErrorMessageImpl = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorMessageImpl, _React$Component);

  function ErrorMessageImpl() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ErrorMessageImpl.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
    if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) {
      return true;
    } else {
      return false;
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        component = _this$props.component,
        formik = _this$props.formik,
        render = _this$props.render,
        children = _this$props.children,
        name = _this$props.name,
        rest = _objectWithoutPropertiesLoose(_this$props, ["component", "formik", "render", "children", "name"]);

    var touch = getIn(formik.touched, name);
    var error = getIn(formik.errors, name);
    return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? Object(react["createElement"])(component, rest, error) : error : null;
  };

  return ErrorMessageImpl;
}(react["Component"]);

var ErrorMessage = /*#__PURE__*/connect(formik_esm_ErrorMessageImpl);

/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */

var formik_esm_FastFieldInner = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FastFieldInner, _React$Component);

  function FastFieldInner(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var render = props.render,
        children = props.children,
        component = props.component,
        is = props.as,
        name = props.name;
    !!render ?  false ? undefined : tiny_warning_esm(false) : void 0;
    !!(component && render) ?  false ? undefined : tiny_warning_esm(false) : void 0;
    !!(is && children && isFunction(children)) ?  false ? undefined : tiny_warning_esm(false) : void 0;
    !!(component && children && isFunction(children)) ?  false ? undefined : tiny_warning_esm(false) : void 0;
    !!(render && children && !formik_esm_isEmptyChildren(children)) ?  false ? undefined : tiny_warning_esm(false) : void 0;
    return _this;
  }

  var _proto = FastFieldInner.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
    if (this.props.shouldUpdate) {
      return this.props.shouldUpdate(props, this.props);
    } else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) {
      return true;
    } else {
      return false;
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    // Register the Field with the parent Formik. Parent will cycle through
    // registered Field's validate fns right prior to submit
    this.props.formik.registerField(this.props.name, {
      validate: this.props.validate
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.name !== prevProps.name) {
      this.props.formik.unregisterField(prevProps.name);
      this.props.formik.registerField(this.props.name, {
        validate: this.props.validate
      });
    }

    if (this.props.validate !== prevProps.validate) {
      this.props.formik.registerField(this.props.name, {
        validate: this.props.validate
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.props.formik.unregisterField(this.props.name);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        name = _this$props.name,
        render = _this$props.render,
        is = _this$props.as,
        children = _this$props.children,
        component = _this$props.component,
        formik = _this$props.formik,
        props = _objectWithoutPropertiesLoose(_this$props, ["validate", "name", "render", "as", "children", "component", "shouldUpdate", "formik"]);

    var restOfFormik = _objectWithoutPropertiesLoose(formik, ["validate", "validationSchema"]);

    var field = formik.getFieldProps(_extends({
      name: name
    }, props));
    var meta = {
      value: getIn(formik.values, name),
      error: getIn(formik.errors, name),
      touched: !!getIn(formik.touched, name),
      initialValue: getIn(formik.initialValues, name),
      initialTouched: !!getIn(formik.initialTouched, name),
      initialError: getIn(formik.initialErrors, name)
    };
    var bag = {
      field: field,
      meta: meta,
      form: restOfFormik
    };

    if (render) {
      return render(bag);
    }

    if (isFunction(children)) {
      return children(bag);
    }

    if (component) {
      // This behavior is backwards compat with earlier Formik 0.9 to 1.x
      if (typeof component === 'string') {
        var innerRef = props.innerRef,
            rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

        return Object(react["createElement"])(component, _extends({
          ref: innerRef
        }, field, rest), children);
      } // We don't pass `meta` for backwards compat


      return Object(react["createElement"])(component, _extends({
        field: field,
        form: formik
      }, props), children);
    } // default to input here so we can check for both `as` and `children` above


    var asElement = is || 'input';

    if (typeof asElement === 'string') {
      var _innerRef = props.innerRef,
          _rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

      return Object(react["createElement"])(asElement, _extends({
        ref: _innerRef
      }, field, _rest), children);
    }

    return Object(react["createElement"])(asElement, _extends({}, field, props), children);
  };

  return FastFieldInner;
}(react["Component"]);

var FastField = /*#__PURE__*/connect(formik_esm_FastFieldInner);


//# sourceMappingURL=formik.esm.js.map


/***/ }),

/***/ "mi0r":
/***/ (function(module, exports) {

if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        var el = this;

        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}


/***/ }),

/***/ "s2Gj":
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__("4ygQ");

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = createCompounder(function(result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

module.exports = kebabCase;


/***/ }),

/***/ "vpua":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INPUT_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getValidationStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getValidateFieldFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return focusNextInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getInputClasses; });
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("QsI/");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("45yR");
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("luEP");
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(yup__WEBPACK_IMPORTED_MODULE_6__);







var INPUT_HEIGHT = 48;
var getValidationStatus = function getValidationStatus(_ref, _ref2) {
  var name = _ref.name,
      value = _ref.value;
  var touched = _ref2.touched,
      errors = _ref2.errors,
      submitCount = _ref2.submitCount;
  var isDisabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var hadInteraction = lodash_get__WEBPACK_IMPORTED_MODULE_2___default()(touched, name) || submitCount > 0;
  var validationState = lodash_get__WEBPACK_IMPORTED_MODULE_2___default()(errors, name) ? _form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_5__[/* IS_INVALID */ "a"] : _form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_5__[/* IS_VALID */ "b"];
  var isValidated = hadInteraction && validationState === _form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_5__[/* IS_VALID */ "b"] && value;
  var isErrored = hadInteraction && validationState === _form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_5__[/* IS_INVALID */ "a"];
  return {
    isDefaultState: !isValidated && !isErrored && !isDisabled,
    isErrored: isErrored,
    isTouched: hadInteraction,
    isValidated: isValidated
  };
};
var getValidateFieldFunction = function getValidateFieldFunction(validator, context) {
  return /*#__PURE__*/function () {
    var _ref3 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee(val) {
      var validationResult;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              validationResult = '';
              _context.prev = 1;
              _context.next = 4;
              return validator.validateSync(val, {
                context: context
              });

            case 4:
              _context.next = 9;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](1);
              validationResult = _context.t0.message;

            case 9:
              return _context.abrupt("return", validationResult);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 6]]);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var focusNextInput = function focusNextInput(target) {
  var nextRef = target.nextSibling;

  if (target.value.length === target.maxLength && nextRef) {
    nextRef.focus();
  }
};
var getInputClasses = function getInputClasses(_ref4) {
  var hasHeight = _ref4.hasHeight,
      _ref4$hasRadius = _ref4.hasRadius,
      hasRadius = _ref4$hasRadius === void 0 ? true : _ref4$hasRadius,
      hasValidationStatus = _ref4.hasValidationStatus,
      isDefaultState = _ref4.isDefaultState,
      isDisabled = _ref4.isDisabled,
      isErrored = _ref4.isErrored,
      isValidated = _ref4.isValidated;
  return classnames__WEBPACK_IMPORTED_MODULE_4___default()('appearance-none border leading-normal outline-none px-20 py-10 text-14 text-black transition-all duration-250 ease-in w-full', {
    'rounded-extra': hasRadius,
    'h-48': hasHeight,
    'border-lightGrey hocus:border-black': isDefaultState,
    'border-success': isValidated,
    'border-red formik-errored': isErrored,
    'border-grey bg-pearl cursor-not-allowed text-grey': isDisabled,
    'pe-40': hasValidationStatus && (isErrored || isValidated)
  });
};

/***/ }),

/***/ "yWv5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Radio; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _inputsUtils__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("vpua");
/* harmony import */ var _form_inputs_radio_button_RadioButton__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("zwQs");
















var __jsx = react__WEBPACK_IMPORTED_MODULE_16___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var Radio = function Radio(_ref) {
  var className = _ref.className,
      field = _ref.field,
      form = _ref.form,
      isDisabled = _ref.isDisabled,
      isLoading = _ref.isLoading,
      isReadOnly = _ref.isReadOnly,
      isRequired = _ref.isRequired,
      label = _ref.label,
      _onChange = _ref.onChange,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size;

  var formValue = lodash_get__WEBPACK_IMPORTED_MODULE_15___default()(form.values, field.name, '');

  var _getValidationStatus = Object(_inputsUtils__WEBPACK_IMPORTED_MODULE_18__[/* getValidationStatus */ "e"])(_objectSpread(_objectSpread({}, field), {}, {
    formValue: formValue
  }), form),
      isErrored = _getValidationStatus.isErrored; // values can be integer at form initialize but finally it's always a string, so we ensure it


  var isChecked = formValue.toString() === field.value.toString();
  return __jsx("label", {
    htmlFor: "radio-".concat(field.name, "-").concat(field.value),
    className: classnames__WEBPACK_IMPORTED_MODULE_17___default()(className, 'flex gap-10 items-center text-14 w-full', {
      'cursor-pointer': !isDisabled && !isLoading,
      'cursor-wait': isLoading,
      'cursor-not-allowed': isDisabled,
      'formik-errored': isErrored && isRequired
    }),
    style: {
      minHeight: _inputsUtils__WEBPACK_IMPORTED_MODULE_18__[/* INPUT_HEIGHT */ "a"]
    }
  }, __jsx(_form_inputs_radio_button_RadioButton__WEBPACK_IMPORTED_MODULE_19__[/* RadioButton */ "a"], {
    isChecked: isChecked,
    isDisabled: isDisabled || isReadOnly,
    size: size
  }), __jsx("input", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])({}, field, {
    checked: isChecked,
    className: "sr-only",
    disabled: isDisabled,
    id: "radio-".concat(field.name, "-").concat(field.value),
    type: "radio",
    onChange: function onChange(event) {
      field.onChange(event);

      if (_onChange) {
        _onChange(event);
      }
    }
  })), label && __jsx("span", {
    className: "leading-normal text-14 text-black"
  }, label));
};

/***/ }),

/***/ "zwQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RadioButton; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_keyCodes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("05v4");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qBqs");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;






var RadioButton = function RadioButton(_ref) {
  var _classnames;

  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].SAFFRON : _ref$color,
      dataTestid = _ref.dataTestid,
      isChecked = _ref.isChecked,
      isDisabled = _ref.isDisabled,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      onClick = _ref.onClick,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;

  var _onClick = function _onClick(event) {
    if (!isDisabled && onClick) {
      onClick(event);
    }
  };

  var _onKeyPress = function _onKeyPress(event) {
    if (event.which === _utils_keyCodes__WEBPACK_IMPORTED_MODULE_5__[/* ENTER */ "f"]) {
      _onClick(event);
    }
  };

  return __jsx("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'border flex outline-custom-sibling p-2 rounded-full shrink-0', (_classnames = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_classnames, "border-black text-".concat(color), !isDisabled), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_classnames, 'bg-pearl border-grey cursor-not-allowed text-lightGrey', isDisabled), _classnames)),
    "data-testid": dataTestid,
    style: {
      width: size,
      height: size
    },
    role: "button",
    tabIndex: tabIndex,
    onClick: _onClick,
    onKeyPress: _onKeyPress
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
      'opacity-0': !isChecked
    }),
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].FAT_DOT,
    width: "100%"
  }));
};

/***/ })

}]);